webpackJsonp([4],{

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PostApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UserApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SearchApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sp_react_commons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sp_react_commons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Uri__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configurations_Constants__ = __webpack_require__(135);
var _class, _temp, _class2, _temp2;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


// import Uri from '../../commons/utils/Uri';




var PostApi = function () {
    function PostApi() {
        _classCallCheck(this, PostApi);
    }

    _createClass(PostApi, null, [{
        key: 'getPostsOrEventsBeforeDate',
        value: function getPostsOrEventsBeforeDate(beforeTimeStamp, contentType) {
            var query = {
                beforeTimeStamp: beforeTimeStamp,
                limit: __WEBPACK_IMPORTED_MODULE_3__configurations_Constants__["a" /* default */].POST_BY_CALL,
                filter: contentType
            };
            return __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__["Request"].get(__WEBPACK_IMPORTED_MODULE_1__utils_Uri__["a" /* default */].buildQuery('/api/v1/' + __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].getLanguageName() + '/mywort/posts', query));
        }
    }, {
        key: 'getEventsAfterDate',
        value: function getEventsAfterDate(afterDate, excludeIds) {
            var query = {
                afterDate: afterDate,
                limit: __WEBPACK_IMPORTED_MODULE_3__configurations_Constants__["a" /* default */].POST_BY_CALL,
                excludeIds: excludeIds
            };
            return __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__["Request"].get(__WEBPACK_IMPORTED_MODULE_1__utils_Uri__["a" /* default */].buildQuery('/api/v1/' + __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].getLanguageName() + '/mywort/events', query));
        }
    }, {
        key: 'getLatestGroups',
        value: function getLatestGroups(skip) {
            var query = {
                skip: skip
            };
            return __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__["Request"].get(__WEBPACK_IMPORTED_MODULE_1__utils_Uri__["a" /* default */].buildQuery('/api/v1/' + __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].getLanguageName() + '/mywort/groups', query));
        }
    }, {
        key: 'getLatestLocalities',
        value: function getLatestLocalities(skip) {
            var query = {
                skip: skip
            };
            return __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__["Request"].get(__WEBPACK_IMPORTED_MODULE_1__utils_Uri__["a" /* default */].buildQuery('/api/v1/' + __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].getLanguageName() + '/mywort/localities', query));
        }
    }, {
        key: 'getPostBeforeDate',
        value: function getPostBeforeDate(beforeTimeStamp) {
            return PostApi.getPostsOrEventsBeforeDate(beforeTimeStamp, __WEBPACK_IMPORTED_MODULE_3__configurations_Constants__["a" /* default */].CONTENT_FILTER.POST);
        }
    }, {
        key: 'getEvents',
        value: function getEvents(date, excludeIds) {
            return PostApi.getEventsAfterDate(date, excludeIds);
        }
    }, {
        key: 'unlinkPost',
        value: function unlinkPost(postId) {
            return __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__["Request"].get('/api/v1/mywort/post/' + postId + '/unlink');
        }
    }]);

    return PostApi;
}();

var UserApi = function () {
    function UserApi() {
        _classCallCheck(this, UserApi);
    }

    _createClass(UserApi, null, [{
        key: 'getUserPosts',
        value: function getUserPosts() {
            return __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__["Request"].get('/api/v1/mywort/posts/own/search');
        }
    }]);

    return UserApi;
}();

var GroupApi = (_temp = _class = function GroupApi() {
    _classCallCheck(this, GroupApi);
}, _class.createGroupRequest = function (groupRequest) {
    return __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__["Request"].post('/api/v1/mywort/groups/create', groupRequest);
}, _class.getGroupRequest = function (legacyUserId) {
    return __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__["Request"].get('/api/v1/mywort/groups/myrequest/legacy/' + legacyUserId);
}, _class.createJoinGroupRequest = function (joinGroupRequest) {
    return __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__["Request"].post('/api/v1/mywort/groups/join', joinGroupRequest);
}, _class.getJoinRequest = function (groupId) {
    return __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__["Request"].get('/api/v1/mywort/groups/' + groupId + '/myjoins');
}, _class.getGroup = function (groupId) {
    return __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__["Request"].get('/api/v1/mywort/groups/' + groupId);
}, _temp);

var SearchApi = (_temp2 = _class2 = function SearchApi() {
    _classCallCheck(this, SearchApi);
}, _class2.searchPosts = function (filters) {
    return __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__["Request"].get(__WEBPACK_IMPORTED_MODULE_1__utils_Uri__["a" /* default */].buildQuery('/api/v1/' + __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].getLanguageName() + '/mywort/search', filters));
}, _class2.searchGroup = function (filters) {
    return __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__["Request"].get(__WEBPACK_IMPORTED_MODULE_1__utils_Uri__["a" /* default */].buildQuery('/api/v1/' + __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].getLanguageName() + '/mywort/groups/search', filters));
}, _class2.searchLocality = function (filters) {
    return __WEBPACK_IMPORTED_MODULE_0_sp_react_commons__["Request"].get(__WEBPACK_IMPORTED_MODULE_1__utils_Uri__["a" /* default */].buildQuery('/api/v1/' + __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].getLanguageName() + '/mywort/localities/search', filters));
}, _temp2);

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    POST_BY_CALL: 11, //Change it when MyWortPage.LATEST_TEASERS_NUMBER is changed !!!
    GEOLOCATION_DISTANCES: [0, 5, 10, 15],
    // Synchronize with backend
    CONTENT_FILTER: {
        POST: "post",
        EVENT: "event",
        POST_OR_EVENT: "post-event"
    },
    SURROUNDING_FILTER: {
        LOCALITY: "l",
        MUNICIPALITY: "m",
        AROUND: "a"
    },
    SEARCH_COMING_FROM: {
        GROUP_PAGE: "group",
        LOCALITY_PAGE: "locality",
        EVENT_MODULE: "event"
    },
    USER_MODULE_POSTS_LIMIT: 5
});

/***/ }),

/***/ 1364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configurations_ExternalDependenciesConfiguration__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styleguide_styleguide__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_utils_ReactBoot__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_legacyGroupRequest_LegacyGroupRequest__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_joinGroupRequest_JoinGroupRequest__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_search_SearchPage__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_post_LandingTabs__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_groupDetailsModal_GroupDetailsModal__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_user_module__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commons_components_user_header_dropdown_UserHeaderDropdown__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commons_components_AddPostButton__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__stores_PostStore__ = __webpack_require__(746);


__WEBPACK_IMPORTED_MODULE_0__configurations_ExternalDependenciesConfiguration__["a" /* default */].configure();







// import UnlinkPost from './pages/unlinkPost/UnlinkPost';







__WEBPACK_IMPORTED_MODULE_12__stores_PostStore__["a" /* default */].initialize(window._react_post_list_data, window._react_event_list_data, window._react_locality_list_data, window._react_group_list_data);

__WEBPACK_IMPORTED_MODULE_2__commons_utils_ReactBoot__["a" /* default */].tryBoot(__WEBPACK_IMPORTED_MODULE_8__components_user_module__["a" /* UserModule */], "mywort-user-module");
__WEBPACK_IMPORTED_MODULE_2__commons_utils_ReactBoot__["a" /* default */].tryBoot(__WEBPACK_IMPORTED_MODULE_9__commons_components_user_header_dropdown_UserHeaderDropdown__["a" /* default */], "mywort-header-dropdown");
__WEBPACK_IMPORTED_MODULE_2__commons_utils_ReactBoot__["a" /* default */].tryBoot(__WEBPACK_IMPORTED_MODULE_10__commons_components_AddPostButton__["a" /* default */], "mywort-header-new-post-action");
__WEBPACK_IMPORTED_MODULE_2__commons_utils_ReactBoot__["a" /* default */].tryBoot(__WEBPACK_IMPORTED_MODULE_10__commons_components_AddPostButton__["a" /* default */], "mywort-header-new-post-action-float", { style: "float" });
__WEBPACK_IMPORTED_MODULE_2__commons_utils_ReactBoot__["a" /* default */].tryBoot(__WEBPACK_IMPORTED_MODULE_11__components__["a" /* MywortSearch */], "mywort-header-search-mount");
__WEBPACK_IMPORTED_MODULE_2__commons_utils_ReactBoot__["a" /* default */].tryBoot(__WEBPACK_IMPORTED_MODULE_3__pages_legacyGroupRequest_LegacyGroupRequest__["a" /* default */], "mywort-group-request");
__WEBPACK_IMPORTED_MODULE_2__commons_utils_ReactBoot__["a" /* default */].tryBoot(__WEBPACK_IMPORTED_MODULE_4__pages_joinGroupRequest_JoinGroupRequest__["a" /* default */], "mywort-join-group-panel");
__WEBPACK_IMPORTED_MODULE_2__commons_utils_ReactBoot__["a" /* default */].tryBoot(__WEBPACK_IMPORTED_MODULE_5__pages_search_SearchPage__["a" /* default */], "mywort-search-page");
__WEBPACK_IMPORTED_MODULE_2__commons_utils_ReactBoot__["a" /* default */].tryBoot(__WEBPACK_IMPORTED_MODULE_6__pages_post_LandingTabs__["a" /* LandingTabs */], "mywort-landing-tabs", { activeTab: window._react_active_tab }, true);
// ReactBoot.tryBoot(UnlinkPost, "mywort-unlink-post");    //TODO is it still used?
__WEBPACK_IMPORTED_MODULE_2__commons_utils_ReactBoot__["a" /* default */].tryBoot(__WEBPACK_IMPORTED_MODULE_7__pages_groupDetailsModal_GroupDetailsModal__["a" /* default */], "mywort-group-details-modal");

/***/ }),

/***/ 1365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExternalDependenciesConfiguration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sp_react_commons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sp_react_commons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sp_react_commons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_validation__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_validation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_validation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_i18n_Translation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_geolocation__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_geolocation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_geolocation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AppConfig__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_AppConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_AppConfig__);


var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//We are coupling here the external dependencies (generic tools/components provided by our github repositories) with the specific functions of this application.
//This file is supposed to be reviewed and potentially rewritten for each application, depending of its structure.







var ExternalDependenciesConfiguration = (_temp = _class = function ExternalDependenciesConfiguration() {
    _classCallCheck(this, ExternalDependenciesConfiguration);
}, _class.configure = function () {
    __WEBPACK_IMPORTED_MODULE_1_sp_react_commons__["Request"].Config.withCredentials = true;

    // React Validation
    __WEBPACK_IMPORTED_MODULE_2_react_validation___default.a.Config.ICON_VALID_CLASS = "icon-check";
    __WEBPACK_IMPORTED_MODULE_2_react_validation___default.a.Config.ICON_ERROR_CLASS = "icon-exclamation-triangle";
    __WEBPACK_IMPORTED_MODULE_2_react_validation___default.a.Config.MESSAGES = __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default()(__WEBPACK_IMPORTED_MODULE_2_react_validation___default.a.Config.MESSAGES, __WEBPACK_IMPORTED_MODULE_3__commons_i18n_Translation__["a" /* default */].get("react-validation.messages"));
    __WEBPACK_IMPORTED_MODULE_2_react_validation___default.a.Config.ERROR_MESSAGE_FIELD_NAME = __WEBPACK_IMPORTED_MODULE_3__commons_i18n_Translation__["a" /* default */].translate("react-validation.error-message-field-name");
    __WEBPACK_IMPORTED_MODULE_2_react_validation___default.a.Config.COUNT_MESSAGE = function (count) {
        return __WEBPACK_IMPORTED_MODULE_3__commons_i18n_Translation__["a" /* default */].translate("react-validation.count-message", { count: count });
    };

    // Geolocation
    __WEBPACK_IMPORTED_MODULE_4_react_geolocation___default.a.Config.GOOGLE_MAPS_API_KEY = __WEBPACK_IMPORTED_MODULE_5_AppConfig___default.a.googleMapApiKey;
}, _temp);


/***/ }),

/***/ 1471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sticky_header__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sticky_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sticky_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropdown__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__infobox__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__infobox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__infobox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__section_navigation__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__section_navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__section_navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__collapse__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__collapse__);
/**
 * Toolkit JavaScript
 * This file was mentioned as "styleguide" but it's not !
 * Everything there is needed for mywort frontend app
 */







__WEBPACK_IMPORTED_MODULE_0__sticky_header___default.a.init('mywort-header-sticky', window);
__WEBPACK_IMPORTED_MODULE_1__dropdown___default.a.init(window);
__WEBPACK_IMPORTED_MODULE_2__infobox___default.a.init(window);
__WEBPACK_IMPORTED_MODULE_3__search___default.a.init();
__WEBPACK_IMPORTED_MODULE_5__collapse___default.a.init();
__WEBPACK_IMPORTED_MODULE_4__section_navigation___default.a.init('mywort-section-navigation');

/***/ }),

/***/ 1472:
/***/ (function(module, exports) {

/**
 *
 * Sticky Header, checks position of header next element and if scrolls out of screen adds a class to header.
 * A Next element is required in the DOM otherwise cannot be detached
 */

var els = [];

module.exports = {

  init: function init(className, window) {
    $('.' + className).each(function () {
      var next = $(this).nextAll('div')[0];
      if (next) {
        // See init scroll position on page
        var doc = document.documentElement;
        var topPosition = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (topPosition >= $(this).outerHeight(true) && !$(this).hasClass('mywort-header--fixed')) {
          $(this).addClass("mywort-header--fixed");
          $('<div id="mywort-header-duply" style="height:' + $(this).outerHeight(true) + 'px"></div>').insertBefore($(this));
        }
        els.push({ that: this, next: next });
      }
    });
    window.addEventListener('scroll', this.scrollHandler);

    var isTouchDevice = 'ontouchstart' in document.documentElement;
    if (isTouchDevice) {
      window.addEventListener('touchmove', this.scrollHandler);
    }
  },

  scrollHandler: function scrollHandler() {
    for (var i = 0; i < els.length; i++) {
      var obj = els[i];
      var next = obj.next;
      var $el = $(obj.that);
      var nextTop = $el.offset().top;
      if (next) {
        nextTop = next.getBoundingClientRect().top;
      }
      if (nextTop - $el.outerHeight(true) <= 0) {
        if (!$el.hasClass('mywort-header--fixed')) {
          $el.addClass("mywort-header--fixed");
          $('<div id="mywort-header-duply" style="height:' + $el.outerHeight(true) + 'px"></div>').insertBefore($el);
          $('.mywort-static-h1').each(function () {
            $(this).addClass('hide');
          });
        }
      } else {
        $('#mywort-header-duply').remove();
        if ($el.hasClass('mywort-header--fixed')) {
          $el.removeClass('mywort-header--fixed');
        }
        $('.mywort-static-h1').each(function () {
          $(this).removeClass('hide');
        });
      }
    }
  }
};

/***/ }),

/***/ 1473:
/***/ (function(module, exports) {

/**
 *
 * Dropdown.
 *
 */

module.exports = {

  init: function init() {
    $('.mywort-dropdown').click(function (e) {
      var target = $(this).attr("drop-target");
      $("." + target).slideToggle(200);
      $(this).toggleClass('mywort-dropdown--open');
      e.stopPropagation();
    });

    $('html').click(function () {
      $('.mywort-dropdown__content, .mywort-header__sub__menu').slideUp(200);
      $(".mywort-dropdown--open").removeClass('mywort-dropdown--open');
    });

    if ($(document).find('.date__container__left').length > 0) {
      var dateContainer = $(".date__container__left").width();
      var dateItem = $(".date__item").width();
      var nbItems = $(".date__item").length;
      var itemsWidth = nbItems * dateItem;

      if (itemsWidth > dateContainer) {
        $(".date__container__displayer").show();
      }
    }
  }
};

/***/ }),

/***/ 1474:
/***/ (function(module, exports) {

/**
 *
 * info-box.
 *
 */

module.exports = {

  init: function init() {
    $('.info-container__close').click(function () {
      $(this).parent().slideToggle(300);
    });
  }
};

/***/ }),

/***/ 1475:
/***/ (function(module, exports) {

/**
 *
 * MyWort Search for Header
 */

module.exports = {

  componentClassName: '.mywort-header-search',
  componentOpenTriggerClassName: '.js-search-trigger--open',
  componentCloseTriggerClassName: '.js-search-trigger--close',
  componentToggleClassName: 'mywort-header-search--expanded',
  headerParentClassName: 'mywort-header',
  headerParentFixedClassName: 'mywort-header--fixed',
  scrollableSelector: '.Select-menu',
  animationTime: 600,

  isDescendant: function isDescendant(parent, child) {
    var node = child.parentNode;
    while (node !== null) {
      if (node === parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  },

  // As Soon as user touches outside of Scroll Area, we call onBlur to close Search
  _windowTouchStart: function _windowTouchStart(ev) {
    var parent = $(this.componentClassName)[0];
    if (this.isDescendant(parent, ev.target)) {
      var select = document.getElementById('mywort-header-search-mount');
      if (!this.isDescendant(select, ev.target)) {
        ev.stopPropagation();
      }
      return;
    }

    window.removeEventListener('touchstart', this.windowTouchStart, true);
    $(parent).find('input').blur();
  },

  _documentTouchMove: function _documentTouchMove(ev) {
    ev.preventDefault();
  },

  _bodyTouchStart: function _bodyTouchStart(ev) {
    if (ev.currentTarget.scrollTop === 0) {
      ev.currentTarget.scrollTop = 1;
    } else if (ev.currentTarget.scrollHeight === ev.currentTarget.scrollTop + ev.currentTarget.offsetHeight) {
      ev.currentTarget.scrollTop -= 1;
    }
  },

  _bodyTouchEnd: function _bodyTouchEnd(ev) {
    ev.stopPropagation();
  },

  _bodyTouchMove: function _bodyTouchMove(ev) {
    ev.stopPropagation();
  },

  _positionHeaderAbsolute: function _positionHeaderAbsolute($header) {
    if (!$header.hasClass(this.headerParentFixedClassName)) {
      $header.css('position', '').css('top', '').css('transform', '');
      return;
    }
    var doc = document.documentElement;
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    var lwHeader = $("#mobile-top-bar").height();
    top = top < lwHeader ? lwHeader : top; // we set a min "top" to always be under the LW header
    $header.css('position', 'absolute').css('top', top + 'px'); //.css('transform', 'none');
  },

  openFullScreenSearch: function openFullScreenSearch($container) {
    // Open and Expand Search Header
    var $header = $container.parents('.' + this.headerParentClassName);
    $container.addClass(this.componentToggleClassName);
    var $input = $container.find('input');

    $input.focus().trigger('mousedown').trigger('keydown');
    $('.mywort-header__center').addClass('u-stretch-100vh');
    $('.mywort-header__center').css('position', 'absolute').css('transform', 'none');

    if (!$header.hasClass(this.headerParentFixedClassName)) {
      $header.addClass(this.headerParentFixedClassName);
    }
  },

  mountFullScreenSearchListeners: function mountFullScreenSearchListeners() {
    // Adding listeners on touch actions to prevent Overscroll on ios, as described here
    // http://stackoverflow.com/questions/10238084/ios-safari-how-to-disable-overscroll-but-allow-scrollable-divs-to-scroll-norma
    var selScrollable = this.scrollableSelector;
    this.documentTouchMove = this._documentTouchMove.bind(this);
    $(document).on('touchmove', this.documentTouchMove);

    this.bodyTouchStart = this._bodyTouchStart.bind(this);
    $('body').on('touchstart', selScrollable, this.bodyTouchStart);

    this.bodyTouchEnd = this._bodyTouchEnd.bind(this);
    $('body').on('touchend', selScrollable, this.bodyTouchEnd);

    this.bodyTouchMove = this._bodyTouchMove.bind(this);
    $('body').on('touchmove', selScrollable, this.bodyTouchMove);
  },

  unMountFullScreenSearch: function unMountFullScreenSearch() {
    // Remove Event Listeners on touch body and document
    var selScrollable = this.scrollableSelector;
    $(document).off('touchmove', this.documentTouchMove);
    $('body').off('touchstart', selScrollable, this.bodyTouchStart);
    $('body').off('touchend', selScrollable, this.bodyTouchEnd);
    $('body').off('touchmove', selScrollable, this.bodyTouchMove);
    window.removeEventListener('touchstart', this.scroller, true);
    clearInterval(this.interval);
  },

  closeFullScreenSearch: function closeFullScreenSearch($container) {

    // Close Seach Header && reset attributes
    $container.removeClass(this.componentToggleClassName);
    var $header = $container.parents('.' + this.headerParentClassName);
    $('.mywort-header__center').removeClass('u-stretch-100vh');
    $header.css('position', '').css('top', '').css('transform', '');
    $('.mywort-header__center').css('position', '').css('top', '').css('transform', '');
    $('#mywort-header-duply').remove();
  },

  init: function init() {
    var that = this;

    $(that.componentClassName).each(function () {
      var $container = $(this);
      // Execute only on event firing from react component when fully mounted
      window.addEventListener('search-mount', function () {
        $container.click(function () {
          $container.find('input').get(0).focus();
        });
        $container.find('input').each(function () {
          $(this).attr('autocomplete', 'off').attr('autocapitalize', 'off').attr('spellcheck', 'false').attr('autocorrect', 'off');
          $(this).focus(function () {
            that.windowTouchStart = that._windowTouchStart.bind(that);
            window.addEventListener('touchstart', that.windowTouchStart, true);
            that.mountFullScreenSearchListeners();
            var $header = $container.parents('.' + this.headerParentClassName);
            if ($header.hasClass(that.headerParentFixedClassName)) {
              var doc = document.documentElement;
              var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
              window.scrollTo(0, top);
              return;
            }

            // Reposition Header if scrolling happens on Page
            that._positionHeaderAbsolute($header);
            that.interval = setInterval(function () {
              var _$header = $container.parents('.' + that.headerParentClassName);
              that._positionHeaderAbsolute(_$header);
            }, 150);
          });

          $(this).blur(function () {
            that.unMountFullScreenSearch();
            var event = document.createEvent('Event');
            event.initEvent('search-close', true, true);
            $container.get(0).dispatchEvent(event);
          });
        });
      });

      // Add listener to open Search on Phones
      $container.find(that.componentOpenTriggerClassName).each(function () {
        $(this).click(function () {
          that.openFullScreenSearch($container);
        });
      });

      // Search close event might come from onBlur, or another touch event
      $container.get(0).addEventListener('search-close', function () {
        that.closeFullScreenSearch($container);
      });
    });
  }
};

/***/ }),

/***/ 1476:
/***/ (function(module, exports) {

/**
 *
 * Section Navigation Scroll to Active Element
 */

module.exports = {
  init: function init(className) {
    $('.' + className).each(function () {
      var activeEl = $(this).find('.mywort-section-navigation__entry--active').first();
      if (activeEl && activeEl.position()) {
        var scrollTo = activeEl.position().left;
        if (scrollTo > 0) {
          $(this).scrollLeft(scrollTo - 30);
        }
      }
    });
  }
};

/***/ }),

/***/ 1477:
/***/ (function(module, exports) {

/**
 *
 * Collapse is used to hide and show items in filters
 *
 */

module.exports = {

  init: function init() {
    var className = 'mywort-collapse';
    $('.' + className).each(function () {
      var that = this;
      var header = $(this).find('.' + className + '__header')[0];
      $(header).click(function () {
        var content = $(that).find('.' + className + '__content')[0];
        $(content).slideToggle(200);
        $(that).toggleClass(className + '--expanded');
      });
    });
  }
};

/***/ }),

/***/ 1478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LegacyGroupRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_split__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_last__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sp_react_commons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sp_react_commons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sp_react_commons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_Api__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons__ = __webpack_require__(5);




function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var LegacyGroupRequest = function (_RefluxComponent) {
    _inherits(LegacyGroupRequest, _RefluxComponent);

    function LegacyGroupRequest(props) {
        _classCallCheck(this, LegacyGroupRequest);

        var _this = _possibleConstructorReturn(this, (LegacyGroupRequest.__proto__ || Object.getPrototypeOf(LegacyGroupRequest)).call(this, props));

        _this.initialState = function () {
            return {
                canCreateRequest: false,
                alreadyCreatedRequest: false,
                showModal: false,
                legacyUserId: __WEBPACK_IMPORTED_MODULE_2_lodash_last___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_split___default()(window.location.href, "/")) // Extract legacy id from latest part of the url
            };
        };

        _this.onRefreshUser = function (data) {
            if (data && data.user) {
                __WEBPACK_IMPORTED_MODULE_5__api_Api__["a" /* GroupApi */].getGroupRequest(_this.state.legacyUserId).then(function (groupRequest) {
                    _this.setState({
                        canCreateRequest: true,
                        alreadyCreatedRequest: groupRequest
                    });
                });
            }
        };

        _this.onSubmit = function (groupRequest) {
            var request = __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default()({ legacyUserId: _this.state.legacyUserId }, groupRequest);
            // Create group request and reload the page if everything is fine
            __WEBPACK_IMPORTED_MODULE_5__api_Api__["a" /* GroupApi */].createGroupRequest(request).then(function () {
                return window.location.reload();
            });
        };

        _this.showModal = function () {
            return _this.setState({ showModal: true });
        };

        _this.hideModal = function () {
            return _this.setState({ showModal: false });
        };

        _this.renderRequestPanel = function () {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: "info-container" },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "div",
                    { className: "info-container__close" },
                    "x"
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "div",
                    { className: "info-container__content info-container__content--feature" },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        "div",
                        { className: "pure-u-1 pure-u-md-20-24 pure-u-lg-20-24 pure-u-sm-24-24" },
                        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                            "div",
                            { className: "orange-bold" },
                            __WEBPACK_IMPORTED_MODULE_6__commons__["l" /* Translation */].translate("public.legacy-group-request.legacy-organisation")
                        ),
                        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("br", null),
                        __WEBPACK_IMPORTED_MODULE_6__commons__["l" /* Translation */].translate("public.legacy-group-request.group-request-message")
                    ),
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        "div",
                        { className: "pure-u-1 pure-u-md-4-24 pure-u-lg-4-24 pure-u-sm-24-24 text-center" },
                        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                            "button",
                            { className: "mywort-btn mywort-btn--orange", onClick: _this.showModal },
                            __WEBPACK_IMPORTED_MODULE_6__commons__["l" /* Translation */].translate("public.legacy-group-request.want-create-group")
                        )
                    )
                )
            );
        };

        _this.renderAlreadyRequestedPanel = function () {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: "info-container" },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "div",
                    { className: "info-container__close" },
                    "x"
                ),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "div",
                    { className: "info-container__content info-container__content--feature" },
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        "div",
                        { className: "pure-u-1 pure-u-md-20-24 pure-u-lg-20-24 pure-u-sm-24-24" },
                        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                            "span",
                            { className: "orange-bold" },
                            __WEBPACK_IMPORTED_MODULE_6__commons__["l" /* Translation */].translate("public.legacy-group-request.already-did-request")
                        ),
                        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                            "span",
                            null,
                            __WEBPACK_IMPORTED_MODULE_6__commons__["l" /* Translation */].translate("public.legacy-group-request.wait-for-validation")
                        )
                    )
                )
            );
        };

        _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commons__["c" /* GroupRequestModal */], { show: _this.state.showModal,
                    onHide: _this.hideModal,
                    onSubmit: _this.onSubmit }),
                _this.state.canCreateRequest ? _this.state.alreadyCreatedRequest ? _this.renderAlreadyRequestedPanel() : _this.renderRequestPanel() : null
            );
        };

        _this.state = _this.initialState();

        _this.listenTo(__WEBPACK_IMPORTED_MODULE_6__commons__["p" /* UserStore */], _this.onRefreshUser);
        return _this;
    }

    return LegacyGroupRequest;
}(__WEBPACK_IMPORTED_MODULE_4_sp_react_commons__["RefluxComponent"]);



/***/ }),

/***/ 1526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JoinGroupRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_split__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_last__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sp_react_commons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sp_react_commons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sp_react_commons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_Api__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_validation__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_validation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_validation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_lib_Modal__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_usermodule_04_png__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_usermodule_04_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_usermodule_04_png__);



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var PANEL_TYPES = {
    JOIN: "Join",
    JOIN_REQUESTED: "JoinRequested",
    OWNERSHIP: "Ownership"
};

var JoinGroupRequest = function (_RefluxComponent) {
    _inherits(JoinGroupRequest, _RefluxComponent);

    function JoinGroupRequest(props) {
        _classCallCheck(this, JoinGroupRequest);

        var _this = _possibleConstructorReturn(this, (JoinGroupRequest.__proto__ || Object.getPrototypeOf(JoinGroupRequest)).call(this, props));

        _this.onRefreshUser = function (data) {
            if (data && data.user) {
                __WEBPACK_IMPORTED_MODULE_4__api_Api__["a" /* GroupApi */].getGroup(_this.state.groupId).then(function (group) {
                    // TODO RCH : hide-group-feature
                    if (group.status === "active") {
                        __WEBPACK_IMPORTED_MODULE_4__api_Api__["a" /* GroupApi */].getJoinRequest(_this.state.groupId).then(function (groupRequest) {
                            if (groupRequest && groupRequest.status === "") _this.setState({ panelType: PANEL_TYPES.JOIN });else if (groupRequest && groupRequest.status === __WEBPACK_IMPORTED_MODULE_7__commons__["a" /* CommonsConstants */].JOIN_REQUEST_STATUS.REQUESTED) _this.setState({ panelType: PANEL_TYPES.JOIN_REQUESTED });
                        });
                    } else if (group.status === "inactive_owner") {
                        _this.setState({ panelType: PANEL_TYPES.OWNERSHIP, groupName: group.name, user: data.user });
                    }
                });
            }
        };

        _this.onChangeComment = function (value) {
            return _this.setState({ comment: value });
        };

        _this.onClickJoinGroup = function () {
            return _this.setState({ show: true });
        };

        _this.onHide = function () {
            return _this.setState({ show: false });
        };

        _this.onSubmit = function (errors) {
            if (!errors) {
                var joinRequest = {
                    groupId: _this.state.groupId,
                    //groupName: this.state.groupName,
                    comment: _this.state.comment
                };
                __WEBPACK_IMPORTED_MODULE_4__api_Api__["a" /* GroupApi */].createJoinGroupRequest(joinRequest).then(function () {
                    return window.location.reload();
                });
            }
        };

        _this.onClickGroupOwnership = function () {
            window.location.href = "mailto:contact@mywort.lu?subject=" + __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("public.group-ownership-request.email-subject") + "[" + _this.state.user.id + "]" + "&body=" + __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("public.group-ownership-request.email-body", { "groupName": _this.state.groupName, "ownerName": _this.state.user.firstName + " " + _this.state.user.lastName });
        };

        _this.renderToJoinPanel = function () {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7__commons__["e" /* MywortModalWrapper */],
                    { show: _this.state.show, onHide: _this.onHide, className: "mywort-group-request-modal", backdrop: true },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_lib_Modal___default.a.Header,
                        { className: "mywort-modal__header", closeButton: true },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_lib_Modal___default.a.Title,
                            { className: "mywort-modal__title" },
                            __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("public.join-group-request.modal.title")
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_sp_react_commons__["AlertBox"], { autoScroll: true,
                        defaultMessage: __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("alert-box.default-message"),
                        reloadMessage: __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("alert-box.reload-message"),
                        "class": "mywort-alert-box mywort-alert-box--inline",
                        alertClasses: {
                            "DEFAULT": "mywort-alert-box--default",
                            "SUCCESS": "mywort-alert-box--success",
                            "INFO": "mywort-alert-box--info",
                            "WARNING": "mywort-alert-box--warning",
                            "ERROR": "mywort-alert-box--error"
                        }
                    }),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_lib_Modal___default.a.Body,
                        null,
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_react_validation__["ValidationField"],
                            { name: "comment", rules: { required: true } },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("textarea", { className: "mywort-modal__join-group-request-comment", value: _this.state.comment, onChange: _this.onChangeComment, disabled: _this.state.success, rows: 4, maxLength: "200" })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_lib_Modal___default.a.Footer,
                        { className: "mywort-modal__footer" },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            "button",
                            { className: "mywort-btn mywort-btn--transparent-gray", onClick: _this.onHide },
                            __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("commons.close")
                        ),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_react_validation__["ValidationSubmit"],
                            { onSuccess: _this.onSubmit, className: "mywort-btn u-text-uppercase" },
                            __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("commons.submit")
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    "div",
                    { className: "info-container info-container--orange" },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        "div",
                        { className: "info-container__content" },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            "div",
                            { className: "info-container__content__left" },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_8__images_usermodule_04_png___default.a })
                        ),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            "div",
                            { className: "info-container__content__right" },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                "div",
                                { className: "info-container__content__right__title" },
                                __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("public.join-group-request.become-maintainer")
                            ),
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                "div",
                                { className: "info-container__content__right__desc" },
                                " ",
                                __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("public.join-group-request.join-group-message")
                            ),
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                "div",
                                { className: "text-center info-container__content__btn" },
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    "button",
                                    { className: "mywort-btn mywort-btn--invert-orange mywort-btn--radius", onClick: _this.onClickJoinGroup },
                                    __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("public.join-group-request.want-join-group")
                                )
                            )
                        )
                    )
                )
            );
        };

        _this.renderAlreadyJoinedPanel = function () {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                "div",
                { className: "info-container info-container--orange" },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    "div",
                    { className: "info-container__content" },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        "div",
                        { className: "info-container__content__left" },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_8__images_usermodule_04_png___default.a })
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        "div",
                        { className: "info-container__content__right info-container__content__right--already-joined" },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            "div",
                            { className: "info-container__content__right__title" },
                            __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("public.join-group-request.already-did-request")
                        ),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            "div",
                            { className: "info-container__content__right__desc" },
                            __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("public.join-group-request.wait-for-validation")
                        )
                    )
                )
            );
        };

        _this.renderOwnershipPanel = function () {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                "div",
                { className: "info-container info-container--orange" },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    "div",
                    { className: "info-container__content" },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        "div",
                        { className: "pure-u-1 pure-u-md-20-24 pure-u-lg-20-24 pure-u-sm-24-24" },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            "div",
                            { className: "row" },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                "div",
                                { className: "pure-u-1 info-container__content__left pure-u-lg-6-24 pure-u-md-6-24 pure-u-sm-24-24" },
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_8__images_usermodule_04_png___default.a })
                            ),
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                "div",
                                { className: "pure-u-1 info-container__content__right pure-u-lg-18-24 pure-u-md-18-24 pure-u-sm-24-24" },
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    "div",
                                    { className: "info-container__content__right__title" },
                                    __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("public.group-ownership-request.become-owner")
                                ),
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    "div",
                                    { className: "info-container__content__right__desc" },
                                    __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("public.group-ownership-request.group-ownership-message")
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        "div",
                        { className: "pure-u-1 pure-u-md-4-24 pure-u-lg-4-24 pure-u-sm-24-24 text-center info-container__content__btn" },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            "button",
                            { className: "mywort-btn mywort-btn--invert-orange mywort-btn--radius", onClick: _this.onClickGroupOwnership },
                            __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("public.group-ownership-request.want-to-own")
                        )
                    )
                )
            );
        };

        _this.render = function () {
            if (_this.state.panelType === PANEL_TYPES.JOIN) return _this.renderToJoinPanel();else if (_this.state.panelType === PANEL_TYPES.JOIN_REQUESTED) return _this.renderAlreadyJoinedPanel();else if (_this.state.panelType === PANEL_TYPES.OWNERSHIP) return _this.renderOwnershipPanel();else return null;
        };

        _this.state = {
            show: false,
            user: {},
            groupName: "",
            panelType: "",
            comment: __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("public.join-group-request.modal.comments-to-owner"),
            groupId: __WEBPACK_IMPORTED_MODULE_1_lodash_last___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_split___default()(window.location.href, "/")) // Extract group id from latest part of the url
        };

        _this.listenTo(__WEBPACK_IMPORTED_MODULE_7__commons__["p" /* UserStore */], _this.onRefreshUser);
        return _this;
    }

    return JoinGroupRequest;
}(__WEBPACK_IMPORTED_MODULE_3_sp_react_commons__["RefluxComponent"]);



/***/ }),

/***/ 1527:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/usermodule/_04.png";

/***/ }),

/***/ 1528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchPageRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Uri__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_Api__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sp_react_commons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sp_react_commons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sp_react_commons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commons_utils_Responsive__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commons_utils_Navigation__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commons__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__configurations_Constants__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commons_i18n_Translation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__desktop_SearchDesktopPage__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mobile_SearchMobilePage__ = __webpack_require__(1552);




var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var SEARCH_TYPES = [{ label: __WEBPACK_IMPORTED_MODULE_13__commons_i18n_Translation__["a" /* default */].translate("commons.posts"), value: __WEBPACK_IMPORTED_MODULE_12__configurations_Constants__["a" /* default */].CONTENT_FILTER.POST }, { label: __WEBPACK_IMPORTED_MODULE_13__commons_i18n_Translation__["a" /* default */].translate("commons.events"), value: __WEBPACK_IMPORTED_MODULE_12__configurations_Constants__["a" /* default */].CONTENT_FILTER.EVENT }];

var SearchPage = (_temp = _class = function (_RefluxComponent) {
    _inherits(SearchPage, _RefluxComponent);

    function SearchPage(props) {
        _classCallCheck(this, SearchPage);

        var _this = _possibleConstructorReturn(this, (SearchPage.__proto__ || Object.getPrototypeOf(SearchPage)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = _this.initialState(props);
        _this.debounced = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(_this.search, 500);
        return _this;
    }

    _createClass(SearchPage, [{
        key: "componentDidUpdate",


        // Search is done on Props changing, coming from the Router
        // only way to trigger search
        // Change URL to come here
        value: function componentDidUpdate(oldProps) {
            if (oldProps.location.search !== this.props.location.search) {
                // Get Locality from Params, but use State if available
                // Avoids empty select box on select
                var locality = this.getLocalityParams(this.props);
                if (locality && this.state.locality && locality.id === this.state.locality.id) {
                    locality = this.state.locality;
                }
                // Get Group from Params, but use State if available
                // Avoids empty select box on select
                var group = this.getGroupParams(this.props);
                if (group && this.state.group && group.id === this.state.group.id) {
                    group = this.state.group;
                }
                // Get Language from Params, but use State if available
                // Avoids empty select box on select
                var language = this.getLanguageParams(this.props);
                if (language && this.state.language && language.id === this.state.language.id) {
                    language = this.state.language;
                }
                this.setState({
                    comingFrom: this.getComingFromParams(this.props),
                    query: this.getQueryParams(this.props),
                    contentType: this.getContentTypeParams(this.props),
                    group: group,
                    language: language,
                    loading: true,
                    locality: locality,
                    surroundings: this.getSurroundingsParams(this.props),
                    eventDate: this.getEventDateParams(this.props)
                }, this.searchDebounce);
            }
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.search();
        }
    }]);

    return SearchPage;
}(__WEBPACK_IMPORTED_MODULE_8_sp_react_commons__["RefluxComponent"]), _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.initialState = function (props) {
        return {
            comingFrom: _this2.getComingFromParams(props),
            query: _this2.getQueryParams(props),
            contentType: _this2.getContentTypeParams(props),
            group: _this2.getGroupParams(props),
            language: _this2.getLanguageParams(props),
            loading: true,
            locality: _this2.getLocalityParams(props),
            surroundings: _this2.getSurroundingsParams(props),
            eventDate: _this2.getEventDateParams(props),
            results: [],
            resultsLocalities: [],
            resultsGroups: [],
            count: undefined // Not used for the moment
        };
    };

    this.searchDebounce = function () {
        return _this2.debounced();
    };

    this.getComingFromParams = function (props) {
        return __WEBPACK_IMPORTED_MODULE_6__utils_Uri__["a" /* default */].getQueryParam(props.location.search, "comingFrom") || undefined;
    };

    this.getQueryParams = function (props) {
        return __WEBPACK_IMPORTED_MODULE_6__utils_Uri__["a" /* default */].getQueryParam(props.location.search, "query") ? decodeURIComponent(__WEBPACK_IMPORTED_MODULE_6__utils_Uri__["a" /* default */].getQueryParam(props.location.search, "query")) : "";
    };

    this.getContentTypeParams = function (props) {
        return __WEBPACK_IMPORTED_MODULE_6__utils_Uri__["a" /* default */].getQueryParam(props.location.search, "type") || __WEBPACK_IMPORTED_MODULE_12__configurations_Constants__["a" /* default */].CONTENT_FILTER.POST;
    };

    this.getSurroundingsParams = function (props) {
        return __WEBPACK_IMPORTED_MODULE_6__utils_Uri__["a" /* default */].getQueryParam(props.location.search, "surroundings") || __WEBPACK_IMPORTED_MODULE_12__configurations_Constants__["a" /* default */].SURROUNDING_FILTER.MUNICIPALITY;
    };

    this.getLocalityParams = function (props) {
        var localityId = __WEBPACK_IMPORTED_MODULE_6__utils_Uri__["a" /* default */].getQueryParam(props.location.search, "locality"); // Param is called locality but hols only ID
        if (!localityId) {
            return null;
        }
        return { id: localityId, name: '' };
    };

    this.getGroupParams = function (props) {
        var groupId = __WEBPACK_IMPORTED_MODULE_6__utils_Uri__["a" /* default */].getQueryParam(props.location.search, "group"); // URL Param is called group but holds only ID
        if (!groupId) {
            return null;
        }
        return { id: groupId, name: '' };
    };

    this.getLanguageParams = function (props) {
        var languageId = __WEBPACK_IMPORTED_MODULE_6__utils_Uri__["a" /* default */].getQueryParam(props.location.search, "language"); // URL Param is called group but holds only ID
        return __WEBPACK_IMPORTED_MODULE_11__commons__["a" /* CommonsConstants */].LANGUAGES.find(function (language) {
            return language.id === languageId;
        }) || null;
    };

    this.getEventDateParams = function (props) {
        var queryString = __WEBPACK_IMPORTED_MODULE_6__utils_Uri__["a" /* default */].getQueryParam(props.location.search, "eventDate");
        if (!queryString) {
            // Set to empty String if not set
            return undefined;
        }
        return queryString;
    };

    this.search = function () {
        _this2.setState({
            loading: true,
            resultsLocalities: [],
            resultsGroups: []
        });
        var filters = __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default()(_this2.state.query ? { query: _this2.state.query } : {}, _this2.state.contentType ? { contentType: _this2.state.contentType } : {}, _this2.state.group ? { groupId: _this2.state.group.id } : {}, _this2.state.language ? { languageId: _this2.state.language.id } : {}, _this2.state.locality ? { localityId: _this2.state.locality.id } : {}, _this2.state.contentType === __WEBPACK_IMPORTED_MODULE_12__configurations_Constants__["a" /* default */].CONTENT_FILTER.EVENT ? { eventDate: _this2.state.eventDate } : {}, _this2.state.surroundings ? { surroundings: _this2.state.surroundings } : {});
        __WEBPACK_IMPORTED_MODULE_7__api_Api__["c" /* SearchApi */].searchPosts(filters).then(function (response) {
            _this2.setState({
                results: response.teasers,
                count: response.count,
                loading: false,
                locality: response.request.locality ? response.request.locality : null,
                group: response.request.group ? response.request.group : null
            });
        });
        if (_this2.state.query && _this2.state.query.length > 2 && !__WEBPACK_IMPORTED_MODULE_9__commons_utils_Responsive__["a" /* default */].isMobile()) {
            // Only displayed on Desktop, so avoid api calls on mobile
            __WEBPACK_IMPORTED_MODULE_7__api_Api__["c" /* SearchApi */].searchLocality({ query: _this2.state.query }).then(function (localities) {
                _this2.setState({
                    resultsLocalities: __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(localities, 'name')
                });
            });
            __WEBPACK_IMPORTED_MODULE_7__api_Api__["c" /* SearchApi */].searchGroup({ query: _this2.state.query }).then(function (groups) {
                _this2.setState({
                    resultsGroups: __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(groups, 'name')
                });
            });
        }
    };

    this.searchGroup = function (query, asyncSelectCallback) {
        __WEBPACK_IMPORTED_MODULE_7__api_Api__["c" /* SearchApi */].searchGroup({ query: query }).then(function (groups) {
            asyncSelectCallback(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(groups, 'name'));
        });
    };

    this.searchLocality = function (query, asyncSelectCallback) {
        __WEBPACK_IMPORTED_MODULE_7__api_Api__["c" /* SearchApi */].searchLocality({ query: query }).then(function (localities) {
            asyncSelectCallback(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(localities, 'name'));
        });
    };

    this.onChangeQuery = function (e) {
        return _this2.setState({ query: e.target.value }, _this2._changeRoute);
    };

    this.onChangeContentType = function (type) {
        return _this2.setState({ contentType: type.value }, _this2._changeRoute);
    };

    this.onChangeGroup = function (group) {
        return _this2.setState({ group: group }, _this2._changeRoute);
    };

    this.onChangeLocality = function (locality) {
        return _this2.setState({ locality: locality }, _this2._changeRoute);
    };

    this.onSetLocality = function (locality) {
        return _this2.setState({ group: null, locality: locality, query: "" }, _this2._changeRoute);
    };

    this.onSetGroup = function (group) {
        return _this2.setState({ group: group, locality: null, query: "" }, _this2._changeRoute);
    };

    this.onChangeEventDate = function (value) {
        var parsedDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(value, __WEBPACK_IMPORTED_MODULE_11__commons__["a" /* CommonsConstants */].SIMPLE_DATE_DISPLAY_FORMAT[__WEBPACK_IMPORTED_MODULE_13__commons_i18n_Translation__["a" /* default */].getLanguageName()], true);
        if (parsedDate.isValid()) {
            var formattedDate = parsedDate.format(__WEBPACK_IMPORTED_MODULE_11__commons__["a" /* CommonsConstants */].SIMPLE_DATE_API_FORMAT);
            _this2.setState({ eventDate: formattedDate }, _this2._changeRoute);
        } else {
            _this2.setState({ eventDate: undefined }, _this2._changeRoute);
        }
    };

    this.onChangeHTML5EventDate = function (ev) {
        if (__WEBPACK_IMPORTED_MODULE_5_moment___default()(ev.target.value, __WEBPACK_IMPORTED_MODULE_11__commons__["a" /* CommonsConstants */].SIMPLE_DATE_API_FORMAT).isValid()) _this2.setState({ eventDate: ev.target.value }, _this2._changeRoute);else {
            _this2.setState({ eventDate: "" }, _this2._changeRoute);
        }
    };

    this.onChangeSurroundings = function (val) {
        return _this2.setState({ surroundings: val.value }, _this2._changeRoute);
    };

    this.onSubmit = function (ev, input) {
        input.blur();
    };

    this.onResetFilters = function () {
        _this2.setState({
            comingFrom: undefined,
            query: "",
            group: null,
            language: null,
            locality: null,
            eventDate: "",
            loading: true,
            results: []
        }, _this2._changeRoute);
    };

    this.onChangeLanguage = function (lang) {
        _this2.setState({ language: lang }, _this2._changeRoute);
    };

    this._changeRoute = function () {
        var query = __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default()(_this2.state.query ? { query: _this2.state.query } : {}, _this2.state.comingFrom ? { comingFrom: _this2.state.comingFrom } : {}, _this2.state.contentType ? { type: _this2.state.contentType } : {}, _this2.state.locality ? { locality: _this2.state.locality.id } : {}, _this2.state.locality ? { surroundings: _this2.state.surroundings } : {}, _this2.state.group ? { group: _this2.state.group.id } : {}, _this2.state.contentType === __WEBPACK_IMPORTED_MODULE_12__configurations_Constants__["a" /* default */].CONTENT_FILTER.EVENT ? { eventDate: _this2.state.eventDate } : {}, _this2.state.language ? { language: _this2.state.language.id } : {});

        __WEBPACK_IMPORTED_MODULE_10__commons_utils_Navigation__["a" /* default */].goTo(__WEBPACK_IMPORTED_MODULE_6__utils_Uri__["a" /* default */].buildQuery("/", query), _this2.props.history);
    };

    this.getCurrentQueryObject = function () {
        var obj = {}; //Posts and events have different parameters that are used
        obj.post = {};
        obj.event = {};
        if (_this2.state.query) {
            obj.post.query = encodeURIComponent(_this2.state.query);
            obj.event.query = encodeURIComponent(_this2.state.query);
        }
        if (_this2.state.locality) {
            obj.post.locality = encodeURIComponent(_this2.state.locality.id);
            obj.event.locality = encodeURIComponent(_this2.state.locality.id);
        }
        if (_this2.state.surroundings) {
            obj.post.surroundings = encodeURIComponent(_this2.state.surroundings);
            obj.event.surroundings = encodeURIComponent(_this2.state.surroundings);
        }
        if (_this2.state.group) {
            obj.post.group = encodeURIComponent(_this2.state.group.id);
            obj.event.group = encodeURIComponent(_this2.state.group.id);
        }
        // There is always a date for events
        obj.event.eventDate = encodeURIComponent(_this2.state.eventDate);

        return obj;
    };

    this.render = function () {
        if (__WEBPACK_IMPORTED_MODULE_9__commons_utils_Responsive__["a" /* default */].isMobile()) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__mobile_SearchMobilePage__["a" /* default */], {
                comingFrom: _this2.state.comingFrom,
                types: SEARCH_TYPES,
                contentType: _this2.state.contentType,
                locality: _this2.state.locality,
                searchLocality: _this2.searchLocality,
                onChangeLocality: _this2.onChangeLocality,
                group: _this2.state.group,
                searchGroup: _this2.searchGroup,
                onChangeGroup: _this2.onChangeGroup,
                eventDate: _this2.state.eventDate,
                onChangeEventDate: _this2.onChangeHTML5EventDate,
                surroundings: _this2.state.surroundings,
                onChangeSurroundings: _this2.onChangeSurroundings,
                query: _this2.state.query,
                onChangeQuery: _this2.onChangeQuery,
                currentQueryObject: _this2.getCurrentQueryObject(),
                results: _this2.state.results,
                loading: _this2.state.loading,
                onSubmit: _this2.onSubmit,
                onResetFilters: _this2.onResetFilters,
                language: _this2.state.language,
                onChangeLanguage: _this2.onChangeLanguage
            });
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__desktop_SearchDesktopPage__["a" /* default */], {
            comingFrom: _this2.state.comingFrom,
            query: _this2.state.query,
            onChangeQuery: _this2.onChangeQuery,
            types: SEARCH_TYPES,
            contentType: _this2.state.contentType,
            onChangeContentType: _this2.onChangeContentType,
            locality: _this2.state.locality,
            searchLocality: _this2.searchLocality,
            onChangeLocality: _this2.onChangeLocality,
            group: _this2.state.group,
            searchGroup: _this2.searchGroup,
            onChangeGroup: _this2.onChangeGroup,
            onSetGroup: _this2.onSetGroup,
            onSetLocality: _this2.onSetLocality,
            eventDate: _this2.state.eventDate,
            onChangeEventDate: _this2.onChangeEventDate,
            surroundings: _this2.state.surroundings,
            onChangeSurroundings: _this2.onChangeSurroundings,
            currentQueryObject: _this2.getCurrentQueryObject(),
            results: _this2.state.results,
            resultsLocalities: _this2.state.resultsLocalities,
            resultsGroups: _this2.state.resultsGroups,
            loading: _this2.state.loading,
            onResetFilters: _this2.onResetFilters,
            language: _this2.state.language,
            onChangeLanguage: _this2.onChangeLanguage
        });
    };
}, _temp);

var SearchPageRouter = function (_React$Component) {
    _inherits(SearchPageRouter, _React$Component);

    function SearchPageRouter() {
        var _ref;

        var _temp2, _this3, _ret;

        _classCallCheck(this, SearchPageRouter);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref = SearchPageRouter.__proto__ || Object.getPrototypeOf(SearchPageRouter)).call.apply(_ref, [this].concat(args))), _this3), _this3.render = function () {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* HashRouter */],
                null,
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */], { path: "/", component: SearchPage })
            );
        }, _temp2), _possibleConstructorReturn(_this3, _ret);
    }

    return SearchPageRouter;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);



/***/ }),

/***/ 1533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchDesktopPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_values__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configurations_Constants__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchSuggestions__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchFilter__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchInputField__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_SearchTitle__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_SearchPostList__ = __webpack_require__(743);


var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var SearchDesktopPage = (_temp2 = _class = function (_React$Component) {
    _inherits(SearchDesktopPage, _React$Component);

    function SearchDesktopPage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchDesktopPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchDesktopPage.__proto__ || Object.getPrototypeOf(SearchDesktopPage)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "section mywort-search-page" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "pure-g container row--expanded" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "pure-u-1 pure-u-sm-16-24 small-centered" },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SearchInputField__["a" /* default */], {
                            query: _this.props.query,
                            onChangeQuery: _this.props.onChangeQuery
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SearchSuggestions__["a" /* default */], {
                    query: _this.props.query,
                    groups: _this.props.resultsGroups,
                    localities: _this.props.resultsLocalities,
                    onSetGroup: _this.props.onSetGroup,
                    onSetLocality: _this.props.onSetLocality
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "section section--minor" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "pure-g container row--expanded" },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            "div",
                            { className: "pure-u-1" },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_SearchTitle__["a" /* default */], { query: _this.props.query })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "pure-g container container--higher-z-index row--expanded mywort-search-page__search-filter-container" },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            "div",
                            { className: "pure-u-1" },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SearchFilter__["a" /* default */], {
                                query: _this.props.query,
                                types: _this.props.types,
                                selected: _this.props.contentType,
                                onChangeQuery: _this.props.onChangeQuery,
                                contentType: _this.props.contentType,
                                onChangeContentType: _this.props.onChangeContentType,
                                locality: _this.props.locality,
                                searchLocality: _this.props.searchLocality,
                                onChangeLocality: _this.props.onChangeLocality,
                                group: _this.props.group,
                                searchGroup: _this.props.searchGroup,
                                onChangeGroup: _this.props.onChangeGroup,
                                eventDate: _this.props.eventDate,
                                onChangeEventDate: _this.props.onChangeEventDate,
                                surroundings: _this.props.surroundings,
                                onChangeSurroundings: _this.props.onChangeSurroundings,
                                onResetFilters: _this.props.onResetFilters,
                                language: _this.props.language,
                                onChangeLanguage: _this.props.onChangeLanguage
                            })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "pure-g container row--expanded" },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            "div",
                            { className: "pure-u-1" },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                "section",
                                { className: "mywort-teaser-list" },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_SearchPostList__["a" /* default */], {
                                    results: _this.props.results,
                                    loading: _this.props.loading,
                                    onResetFilters: _this.props.onResetFilters
                                })
                            )
                        )
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return SearchDesktopPage;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
    query: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    onChangeQuery: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    types: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    contentType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([__WEBPACK_IMPORTED_MODULE_3__configurations_Constants__["a" /* default */].CONTENT_FILTER.POST, __WEBPACK_IMPORTED_MODULE_3__configurations_Constants__["a" /* default */].CONTENT_FILTER.EVENT]),
    onChangeContentType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    locality: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    searchLocality: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onChangeLocality: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    group: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    searchGroup: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onChangeGroup: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onSetGroup: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onSetLocality: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    eventDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    onChangeEventDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    surroundings: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_0_lodash_values___default()(__WEBPACK_IMPORTED_MODULE_3__configurations_Constants__["a" /* default */].SURROUNDING_FILTER)),
    onChangeSurroundings: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    currentQueryObject: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    results: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    resultsLocalities: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    resultsGroups: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    loading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    onResetFilters: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    language: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    onChangeLanguage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
}, _temp2);


/***/ }),

/***/ 1534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchSuggestions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_i18n_Translation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_Svg__ = __webpack_require__(7);


var _class3, _temp3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SearchSuggestionOrganizationPresenter = function (_React$Component) {
    _inherits(SearchSuggestionOrganizationPresenter, _React$Component);

    function SearchSuggestionOrganizationPresenter() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchSuggestionOrganizationPresenter);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchSuggestionOrganizationPresenter.__proto__ || Object.getPrototypeOf(SearchSuggestionOrganizationPresenter)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "a",
                { href: _this.props.url, key: _this.props.keyHandler + '-item', className: "mywort-search-suggestion-card" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "mywort-search-suggestion-card__title" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_Svg__["a" /* default */], { id: "fa-users", className: "u-text-mywort mywort-search-suggestion-card__title__svg" }),
                    _this.props.label
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "mywort-search-suggestion-card__content" },
                    _this.props.description
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "mywort-search-suggestion-card__locality" },
                    _this.props.locality
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return SearchSuggestionOrganizationPresenter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var SearchSuggestionPresenter = function (_React$Component2) {
    _inherits(SearchSuggestionPresenter, _React$Component2);

    function SearchSuggestionPresenter() {
        var _ref2;

        var _temp2, _this2, _ret2;

        _classCallCheck(this, SearchSuggestionPresenter);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = SearchSuggestionPresenter.__proto__ || Object.getPrototypeOf(SearchSuggestionPresenter)).call.apply(_ref2, [this].concat(args))), _this2), _this2.renderSubtitle = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "small",
                null,
                _this2.props.subtitle ? "(" + _this2.props.subtitle + ")" : "",
                "\xA0"
            );
        }, _this2.render = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "a",
                { href: _this2.props.url, key: _this2.props.keyHandler + '-item', className: "mywort-search-suggestion" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "figure",
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { src: _this2.props.pictureUrl, alt: _this2.props.label })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "mywort-search-suggestion__title" },
                    _this2.props.label,
                    _this2.renderSubtitle()
                )
            );
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    return SearchSuggestionPresenter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var SearchSuggestions = (_temp3 = _class3 = function (_React$Component3) {
    _inherits(SearchSuggestions, _React$Component3);

    function SearchSuggestions(props) {
        _classCallCheck(this, SearchSuggestions);

        var _this3 = _possibleConstructorReturn(this, (SearchSuggestions.__proto__ || Object.getPrototypeOf(SearchSuggestions)).call(this, props));

        _this3.getInitialState = function () {
            return {
                leftMarginRequired: _this3.computeMarginLeft()
            };
        };

        _this3.componentDidMount = function () {
            _this3.setState({
                leftMarginRequired: _this3.computeMarginLeft()
            });
        };

        _this3.computeMarginLeft = function () {
            var left = 0;
            var element = document.querySelector('.mywort-teaser-list');
            if (element) {
                left = element.getBoundingClientRect().left;
            }
            return left;
        };

        _this3.renderTitleLocality = function () {
            if (_this3.props.localities.length === 1) {
                return __WEBPACK_IMPORTED_MODULE_3__commons_i18n_Translation__["a" /* default */].translate("search.suggestions.locality");
            }
            return __WEBPACK_IMPORTED_MODULE_3__commons_i18n_Translation__["a" /* default */].translate("search.suggestions.localities");
        };

        _this3.renderLocalities = function () {
            if (_this3.props.localities.length === 0) {
                return null;
            }
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "section",
                { className: "suggestions-section" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "suggestions-section__content" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "pure-g" },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            "div",
                            { className: "pure-u-1" },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                "h2",
                                { className: "suggestions-section__title" },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    "b",
                                    null,
                                    _this3.props.localities.length
                                ),
                                " ",
                                _this3.renderTitleLocality(),
                                " ",
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    "b",
                                    null,
                                    "\"",
                                    _this3.props.query,
                                    "\""
                                ),
                                ":"
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "suggestions-scroller" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "suggestions-scroller__wrapper", style: { 'paddingLeft': _this3.state.leftMarginRequired + 'px' } },
                        __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(_this3.props.localities, 'name').map(function (locality, idx) {
                            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                "div",
                                { className: "suggestions-scroller__item", key: "locality-sugestion-" + idx },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SearchSuggestionPresenter, {
                                    keyHandler: "locality-sugestion-" + idx,
                                    label: locality.name,
                                    subtitle: locality.municipalityName,
                                    pictureUrl: locality.picture,
                                    url: locality.permaLink,
                                    onclick: function onclick() {
                                        _this3.props.onSetLocality(locality);
                                    } })
                            );
                        })
                    )
                )
            );
        };

        _this3.renderTitleGroup = function () {
            if (_this3.props.localities.length === 1) {
                return __WEBPACK_IMPORTED_MODULE_3__commons_i18n_Translation__["a" /* default */].translate("search.suggestions.group");
            }
            return __WEBPACK_IMPORTED_MODULE_3__commons_i18n_Translation__["a" /* default */].translate("search.suggestions.groups");
        };

        _this3.renderGroups = function () {
            if (_this3.props.groups.length === 0) {
                return null;
            }
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "section",
                { className: "suggestions-section" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "suggestions-section__content" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "pure-g" },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            "div",
                            { className: "pure-u-1" },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                "h2",
                                { className: "suggestions-section__title" },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    "b",
                                    null,
                                    _this3.props.groups.length
                                ),
                                " ",
                                _this3.renderTitleGroup(),
                                " ",
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    "b",
                                    null,
                                    "\"",
                                    _this3.props.query,
                                    "\""
                                ),
                                ":"
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "suggestions-scroller" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "suggestions-scroller__wrapper", style: { 'paddingLeft': _this3.state.leftMarginRequired + 'px' } },
                        __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(_this3.props.groups, 'name').map(function (group, idx) {
                            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                "div",
                                { className: "suggestions-scroller__item suggestions-scroller__item--2x", key: "group-sugestion-" + idx },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SearchSuggestionOrganizationPresenter, {
                                    keyHandler: "group-sugestion-" + idx,
                                    label: group.name,
                                    locality: group.locality,
                                    description: group.description,
                                    url: group.permaLink,
                                    onclick: function onclick() {
                                        _this3.props.onSetGroup(group);
                                    }
                                })
                            );
                        })
                    )
                )
            );
        };

        _this3.render = function () {
            if (_this3.props.groups.length === 0 && _this3.props.localities.length === 0) {
                return null;
            }
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "section" },
                _this3.renderLocalities(),
                _this3.renderGroups()
            );
        };

        _this3.state = _this3.getInitialState();
        return _this3;
    }

    return SearchSuggestions;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class3.propTypes = {
    query: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    groups: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    localities: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    onSetGroup: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onSetLocality: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
}, _class3.defaultProps = {
    query: "",
    groups: [],
    localities: [],
    onSetGroup: function onSetGroup() {},
    onSetLocality: function onSetLocality() {}
}, _temp3);


/***/ }),

/***/ 1535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_values__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DayPicker__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configurations_Constants__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_index__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commons_components_CustomSelect__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CustomSelectNullSafe__ = __webpack_require__(1545);


var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var SearchFilter = (_temp2 = _class = function (_React$Component) {
    _inherits(SearchFilter, _React$Component);

    function SearchFilter() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchFilter);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchFilter.__proto__ || Object.getPrototypeOf(SearchFilter)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = function (newProps) {
            // Query
            if (newProps.query.length === 0 !== (_this.props.query.length === 0)) {
                return true;
            }
            // Type
            if (newProps.contentType !== _this.props.contentType) {
                return true;
            }

            if (newProps.surroundings !== _this.props.surroundings) {
                return true;
            }
            // EventDate
            if (newProps.eventDate !== _this.props.eventDate) {
                return true;
            }
            // City
            if (!_this.objectExistsAndSameProperty(newProps.locality, _this.props.locality, 'id') || !_this.objectExistsAndSameProperty(newProps.locality, _this.props.locality, 'name')) {
                // Locality Name is fetched lazy, do not update when id is set but not name
                return true;
            }
            // Organisation
            if (!_this.objectExistsAndSameProperty(newProps.group, _this.props.group, 'id') || !_this.objectExistsAndSameProperty(newProps.group, _this.props.group, 'name')) {
                // Group Name is fetched lazy, do not update when id is set but not name
                return true;
            }
            // Language
            if (!_this.objectExistsAndSameProperty(newProps.language, _this.props.language, 'id') || !_this.objectExistsAndSameProperty(newProps.language, _this.props.language, 'name')) {
                // language Name is fetched lazy, do not update when id is set but not name
                return true;
            }
            return false;
        }, _this.objectExistsAndSameProperty = function (obj1, obj2, prop) {
            if (!obj1 && !obj2) {
                return true;
            }

            if (!obj1 || !obj2) {
                return false;
            }

            if (obj1[prop] === obj2[prop]) {
                return true;
            }
            return false;
        }, _this.isEvent = function () {
            return _this.props.contentType === __WEBPACK_IMPORTED_MODULE_6__configurations_Constants__["a" /* default */].CONTENT_FILTER.EVENT;
        }, _this.onResetFilters = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.props.onResetFilters();
        }, _this.renderLocality = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'mywort-filters__section' },
                _this.renderCitySelect()
            );
        }, _this.renderContentType = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'mywort-filters__section mywort-filters__section--first mywort-filters__section--small' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commons_components_CustomSelect__["a" /* default */], {
                    'aria-label': _this.props.types.map(function (el) {
                        return el.label;
                    }).join(", "),
                    options: _this.props.types,
                    value: _this.props.selected,
                    onChange: _this.props.onChangeContentType,
                    searchable: false,
                    clearable: false,
                    valueKey: 'value',
                    labelKey: 'label'
                })
            );
        }, _this.renderEventDate = function () {
            var parsedDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.props.eventDate, __WEBPACK_IMPORTED_MODULE_7__commons_index__["a" /* CommonsConstants */].SIMPLE_DATE_API_FORMAT);
            var eventDate = parsedDate.isValid() ? parsedDate.format(__WEBPACK_IMPORTED_MODULE_7__commons_index__["a" /* CommonsConstants */].SIMPLE_DATE_DISPLAY_FORMAT[__WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].getLanguageName()]) : "";

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'mywort-filters__section mywort-filters__section--fixed' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'label',
                    { className: 'u-sr-only' },
                    __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("search.filters.date.placeholder")
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_DayPicker__["a" /* default */], {
                    value: eventDate,
                    onDayChange: _this.props.onChangeEventDate,
                    placeholder: __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("search.filters.date.placeholder"),
                    parseDate: function parseDate(date) {
                        var momentDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, __WEBPACK_IMPORTED_MODULE_7__commons_index__["a" /* CommonsConstants */].SIMPLE_DATE_DISPLAY_FORMAT[__WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].getLanguageName()], true);
                        return momentDate.isValid() ? momentDate.toDate() : undefined;
                    },
                    locale: __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].getLanguageName()
                })
            );
        }, _this.renderCitySelect = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CustomSelectNullSafe__["a" /* default */], {
                'aria-label': __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("commons.locality"),
                searchPromptText: __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("search.starttyping"),
                searchingText: __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("search.loading"),
                async: true, debounceTime: 500,
                placeholder: __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("commons.locality"),
                value: _this.props.locality,
                onChange: _this.props.onChangeLocality,
                loadOptions: function loadOptions(input, asyncSelectCallback) {
                    return _this.props.searchLocality(input, asyncSelectCallback);
                },
                valueKey: 'id',
                labelKey: 'name',
                minimumInput: 2
            });
        }, _this.renderSurroundings = function () {
            var options = [{ label: __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("search.filters.locality"), value: __WEBPACK_IMPORTED_MODULE_6__configurations_Constants__["a" /* default */].SURROUNDING_FILTER.LOCALITY }, { label: __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("search.filters.municipality"), value: __WEBPACK_IMPORTED_MODULE_6__configurations_Constants__["a" /* default */].SURROUNDING_FILTER.MUNICIPALITY }, { label: __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("search.filters.around"), value: __WEBPACK_IMPORTED_MODULE_6__configurations_Constants__["a" /* default */].SURROUNDING_FILTER.AROUND }];
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'mywort-filters__section mywort-filters__section--small' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commons_components_CustomSelect__["a" /* default */], {
                    'aria-label': __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("commons.locality"),
                    options: options,
                    value: _this.props.surroundings,
                    onChange: _this.props.onChangeSurroundings,
                    searchable: false,
                    clearable: false,
                    valueKey: 'value',
                    labelKey: 'label'
                })
            );
        }, _this.renderGroupSelect = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CustomSelectNullSafe__["a" /* default */], {
                async: true, debounceTime: 500,
                'aria-label': __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("commons.group"),
                placeholder: __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("commons.group"),
                value: _this.props.group,
                onChange: _this.props.onChangeGroup,
                loadOptions: function loadOptions(input, asyncSelectCallback) {
                    return _this.props.searchGroup(input, asyncSelectCallback);
                },
                valueKey: 'id',
                labelKey: 'name',
                minimumInput: 2
            });
        }, _this.renderGroup = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'mywort-filters__section' },
                _this.renderGroupSelect()
            );
        }, _this.renderLanguage = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'mywort-filters__section mywort-filters__section--first mywort-filters__section--small' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commons_components_CustomSelect__["a" /* default */], {
                    'aria-label': __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("commons.language"),
                    placeholder: __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("commons.language"),
                    value: _this.props.language,
                    onChange: _this.props.onChangeLanguage,
                    options: __WEBPACK_IMPORTED_MODULE_7__commons_index__["a" /* CommonsConstants */].LANGUAGES,
                    valueKey: 'id',
                    labelKey: 'name',
                    searchable: false,
                    clearable: true
                })
            );
        }, _this.renderClearFilter = function () {
            if (!_this.props.query && !_this.props.locality && !_this.props.group && !_this.props.eventDate) {
                return null;
            }
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'mywort-filters__section mywort-filters__section--last' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    { href: '', className: 'mywort-filters__reset-filters mywort-link mywort-link--gray',
                        onClick: _this.onResetFilters },
                    __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("search.filters.reset")
                )
            );
        }, _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'mywort-filters mywort-filters--inline' },
                _this.renderContentType(),
                _this.renderLocality(),
                _this.props.locality ? _this.renderSurroundings() : null,
                _this.renderGroup(),
                _this.renderLanguage(),
                _this.isEvent() ? _this.renderEventDate() : null,
                _this.renderClearFilter()
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return SearchFilter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
    query: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    onChangeQuery: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    contentType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([__WEBPACK_IMPORTED_MODULE_6__configurations_Constants__["a" /* default */].CONTENT_FILTER.POST, __WEBPACK_IMPORTED_MODULE_6__configurations_Constants__["a" /* default */].CONTENT_FILTER.EVENT]),
    onChangeContentType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    locality: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    searchLocality: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onChangeLocality: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    group: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    searchGroup: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onChangeGroup: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    eventDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    onChangeEventDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    surroundings: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_0_lodash_values___default()(__WEBPACK_IMPORTED_MODULE_6__configurations_Constants__["a" /* default */].SURROUNDING_FILTER)),
    onChangeSurroundings: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onResetFilters: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    language: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    onChangeLanguage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
}, _temp2);


/***/ }),

/***/ 1536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DayPicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_de__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_locale_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_fr__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_locale_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_day_picker_DayPickerInput__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_day_picker_DayPickerInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_day_picker_DayPickerInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_Svg__ = __webpack_require__(7);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// Require moment with german locale







// Wrapper for react-day-picker component (source: https://github.com/gpbl/react-day-picker)
var DayPicker = (_temp = _class = function (_React$Component) {
    _inherits(DayPicker, _React$Component);

    function DayPicker(props) {
        _classCallCheck(this, DayPicker);

        // Set the current locale
        var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

        _this.initialState = function () {
            return {
                showDayPicker: false
            };
        };

        _this.handleIconClick = function () {
            // Trick to force to show the calendar if user click on the icon
            _this.dayPickerInput.input.focus();
            _this.dayPickerInput.handleInputFocus();
        };

        _this.renderDayPicker = function () {
            var newProps = __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default()({
                dayPickerProps: __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default()({
                    months: _this._months,
                    weekdaysLong: _this._weekdaysLong,
                    weekdaysShort: _this._weekdaysShort,
                    firstDayOfWeek: 1
                }, _this.props.dayPickerProps)
            }, _this.props);

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_day_picker_DayPickerInput___default.a, _extends({}, newProps, { ref: function ref(d) {
                    return _this.dayPickerInput = d;
                } }));
        };

        _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "DayPicker-Container" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__svg_Svg__["a" /* default */], { id: "fa-calendar", className: "DayPicker-icon u-hover-cursor", onClick: _this.handleIconClick }),
                _this.renderDayPicker()
            );
        };

        __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale(_this.props.locale);

        // Get translations from moment
        _this._months = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.months();
        _this._weekdaysLong = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.weekdays();
        _this._weekdaysShort = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.weekdaysMin();

        _this.state = _this.initialState();
        _this.dayPickerInput = undefined;
        return _this;
    }

    return DayPicker;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.defaultProps = {
    locale: "de"
}, _temp);


/***/ }),

/***/ 1537:
/***/ (function(module, exports, __webpack_require__) {

/*
  Used to import DayPickerInput. e.g. `import DayPickerInput from 'react-day-picker/DayPickerInput'`
*/

/* eslint-disable no-var */
/* eslint-env node */

var DayPickerInput = __webpack_require__(1538);

module.exports = DayPickerInput;


/***/ }),

/***/ 1538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HIDE_TIMEOUT = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.OverlayComponent = OverlayComponent;
exports.defaultFormat = defaultFormat;
exports.defaultParse = defaultParse;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(92);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DayPicker = __webpack_require__(739);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _DateUtils = __webpack_require__(137);

var _ModifiersUtils = __webpack_require__(302);

var _keys = __webpack_require__(214);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// When clicking on a day cell, overlay will be hidden after this timeout
var HIDE_TIMEOUT = exports.HIDE_TIMEOUT = 100;

/**
 * The default component used as Overlay.
 *
 * @param {Object} props
 */
function OverlayComponent(_ref) {
  var input = _ref.input,
      selectedDay = _ref.selectedDay,
      month = _ref.month,
      children = _ref.children,
      classNames = _ref.classNames,
      props = _objectWithoutProperties(_ref, ['input', 'selectedDay', 'month', 'children', 'classNames']);

  return _react2.default.createElement(
    'div',
    _extends({ className: classNames.overlayWrapper }, props),
    _react2.default.createElement(
      'div',
      { className: classNames.overlay },
      children
    )
  );
}

OverlayComponent.propTypes =  false ? {
  input: _propTypes2.default.any,
  selectedDay: _propTypes2.default.any,
  month: _propTypes2.default.instanceOf(Date),
  children: _propTypes2.default.node,
  classNames: _propTypes2.default.object
} : {};

/**
 * The default function used to format a Date to String, passed to the `format`
 * prop.
 * @param {Date} d
 * @return {String}
 */
function defaultFormat(d) {
  if ((0, _DateUtils.isDate)(d)) {
    var year = d.getFullYear();
    var month = '' + (d.getMonth() + 1);
    var day = '' + d.getDate();
    return year + '-' + month + '-' + day;
  }
  return '';
}

/**
 * The default function used to parse a String as Date, passed to the `parse`
 * prop.
 * @param {String} str
 * @return {Date}
 */
function defaultParse(str) {
  if (typeof str !== 'string') {
    return undefined;
  }
  var split = str.split('-');
  if (split.length !== 3) {
    return undefined;
  }
  var year = parseInt(split[0], 10);
  var month = parseInt(split[1], 10) - 1;
  var day = parseInt(split[2], 10);
  if (isNaN(year) || String(year).length > 4 || isNaN(month) || isNaN(day) || day <= 0 || day > 31 || month < 0 || month >= 12) {
    return undefined;
  }

  return new Date(year, month, day);
}

var DayPickerInput = function (_React$Component) {
  _inherits(DayPickerInput, _React$Component);

  function DayPickerInput(props) {
    _classCallCheck(this, DayPickerInput);

    var _this = _possibleConstructorReturn(this, (DayPickerInput.__proto__ || Object.getPrototypeOf(DayPickerInput)).call(this, props));

    _this.input = null;
    _this.daypicker = null;
    _this.clickTimeout = null;
    _this.hideTimeout = null;
    _this.inputBlurTimeout = null;
    _this.inputFocusTimeout = null;


    _this.state = _this.getInitialStateFromProps(props);
    _this.state.showOverlay = props.showOverlay;

    _this.hideAfterDayClick = _this.hideAfterDayClick.bind(_this);
    _this.handleInputClick = _this.handleInputClick.bind(_this);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
    _this.handleInputKeyUp = _this.handleInputKeyUp.bind(_this);
    _this.handleDayClick = _this.handleDayClick.bind(_this);
    _this.handleMonthChange = _this.handleMonthChange.bind(_this);
    _this.handleOverlayFocus = _this.handleOverlayFocus.bind(_this);
    _this.handleOverlayBlur = _this.handleOverlayBlur.bind(_this);
    return _this;
  }

  _createClass(DayPickerInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var newState = {};

      // Current props
      var _props = this.props,
          value = _props.value,
          formatDate = _props.formatDate,
          format = _props.format,
          dayPickerProps = _props.dayPickerProps;

      // Update the input value if the `value` prop has changed

      if (value !== prevProps.value) {
        if ((0, _DateUtils.isDate)(value)) {
          newState.value = formatDate(value, format, dayPickerProps.locale);
        } else {
          newState.value = value;
        }
      }

      // Update the month if the months from props changed
      var prevMonth = prevProps.dayPickerProps.month;
      if (dayPickerProps.month && dayPickerProps.month !== prevMonth && !(0, _DateUtils.isSameMonth)(dayPickerProps.month, prevMonth)) {
        newState.month = dayPickerProps.month;
      }

      // Updated the selected days from props if they changed
      if (prevProps.dayPickerProps.selectedDays !== dayPickerProps.selectedDays) {
        newState.selectedDays = dayPickerProps.selectedDays;
      }

      if (Object.keys(newState).length > 0) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState(newState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.clickTimeout);
      clearTimeout(this.hideTimeout);
      clearTimeout(this.inputFocusTimeout);
      clearTimeout(this.inputBlurTimeout);
      clearTimeout(this.overlayBlurTimeout);
    }
  }, {
    key: 'getInitialMonthFromProps',
    value: function getInitialMonthFromProps(props) {
      var dayPickerProps = props.dayPickerProps,
          format = props.format;

      var day = void 0;
      if (props.value) {
        if ((0, _DateUtils.isDate)(props.value)) {
          day = props.value;
        } else {
          day = props.parseDate(props.value, format, dayPickerProps.locale);
        }
      }
      return dayPickerProps.initialMonth || dayPickerProps.month || day || new Date();
    }
  }, {
    key: 'getInitialStateFromProps',
    value: function getInitialStateFromProps(props) {
      var dayPickerProps = props.dayPickerProps,
          formatDate = props.formatDate,
          format = props.format;
      var value = props.value;

      if (props.value && (0, _DateUtils.isDate)(props.value)) {
        value = formatDate(props.value, format, dayPickerProps.locale);
      }
      return {
        value: value,
        month: this.getInitialMonthFromProps(props),
        selectedDays: dayPickerProps.selectedDays
      };
    }
  }, {
    key: 'getInput',
    value: function getInput() {
      return this.input;
    }
  }, {
    key: 'getDayPicker',
    value: function getDayPicker() {
      return this.daypicker;
    }
  }, {
    key: 'updateState',


    /**
     * Update the component's state and fire the `onDayChange` event passing the
     * day's modifiers to it.
     *
     * @param {Date} day - Will be used for changing the month
     * @param {String} value - Input field value
     * @private
     */
    value: function updateState(day, value, callback) {
      var _props2 = this.props,
          dayPickerProps = _props2.dayPickerProps,
          onDayChange = _props2.onDayChange;

      this.setState({ month: day, value: value }, function () {
        if (callback) {
          callback();
        }
        if (!onDayChange) {
          return;
        }
        var modifiersObj = _extends({
          disabled: dayPickerProps.disabledDays,
          selected: dayPickerProps.selectedDays
        }, dayPickerProps.modifiers);
        var modifiers = (0, _ModifiersUtils.getModifiersForDay)(day, modifiersObj).reduce(function (obj, modifier) {
          var newObj = _extends({}, obj);
          newObj[modifier] = true;
          return newObj;
        }, {});
        onDayChange(day, modifiers);
      });
    }

    /**
     * Show the Day Picker overlay.
     *
     * @memberof DayPickerInput
     */

  }, {
    key: 'showDayPicker',
    value: function showDayPicker() {
      var _props3 = this.props,
          parseDate = _props3.parseDate,
          format = _props3.format,
          dayPickerProps = _props3.dayPickerProps;
      var _state = this.state,
          value = _state.value,
          showOverlay = _state.showOverlay;

      if (showOverlay) {
        return;
      }
      // Reset the current displayed month when showing the overlay
      var month = value ? parseDate(value, format, dayPickerProps.locale) // Use the month in the input field
      : this.getInitialMonthFromProps(this.props); // Restore the month from the props
      this.setState({
        showOverlay: true,
        month: month || this.state.month
      });
    }

    /**
     * Hide the Day Picker overlay
     *
     * @memberof DayPickerInput
     */

  }, {
    key: 'hideDayPicker',
    value: function hideDayPicker() {
      if (this.state.showOverlay === false) {
        return;
      }
      this.setState({ showOverlay: false });
    }
  }, {
    key: 'hideAfterDayClick',
    value: function hideAfterDayClick() {
      var _this2 = this;

      if (!this.props.hideOnDayClick) {
        return;
      }
      this.hideTimeout = setTimeout(function () {
        return _this2.hideDayPicker();
      }, HIDE_TIMEOUT);
    }
  }, {
    key: 'handleInputClick',
    value: function handleInputClick(e) {
      this.showDayPicker();
      if (this.props.inputProps.onClick) {
        e.persist();
        this.props.inputProps.onClick(e);
      }
    }
  }, {
    key: 'handleInputFocus',
    value: function handleInputFocus(e) {
      var _this3 = this;

      this.showDayPicker();
      // Set `overlayHasFocus` after a timeout so the overlay can be hidden when
      // the input is blurred
      this.inputFocusTimeout = setTimeout(function () {
        _this3.overlayHasFocus = false;
      }, 2);
      if (this.props.inputProps.onFocus) {
        e.persist();
        this.props.inputProps.onFocus(e);
      }
    }

    // When the input is blurred, the overlay should disappear. However the input
    // is blurred also when the user interacts with the overlay (e.g. the overlay
    // get the focus by clicking it). In these cases, the overlay should not be
    // hidden. There are different approaches to avoid hiding the overlay when
    // this happens, but the only cross-browser hack we’ve found is to set all
    // these timeouts in code before changing `overlayHasFocus`.

  }, {
    key: 'handleInputBlur',
    value: function handleInputBlur(e) {
      var _this4 = this;

      this.inputBlurTimeout = setTimeout(function () {
        if (!_this4.overlayHasFocus) {
          _this4.hideDayPicker();
        }
      }, 1);
      if (this.props.inputProps.onBlur) {
        e.persist();
        this.props.inputProps.onBlur(e);
      }
    }
  }, {
    key: 'handleOverlayFocus',
    value: function handleOverlayFocus(e) {
      e.preventDefault();
      this.overlayHasFocus = true;
      if (!this.props.keepFocus) {
        return;
      }
      this.input.focus();
    }
  }, {
    key: 'handleOverlayBlur',
    value: function handleOverlayBlur() {
      var _this5 = this;

      // We need to set a timeout otherwise IE11 will hide the overlay when
      // focusing it
      this.overlayBlurTimeout = setTimeout(function () {
        _this5.overlayHasFocus = false;
      }, 3);
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(e) {
      var _props4 = this.props,
          dayPickerProps = _props4.dayPickerProps,
          format = _props4.format,
          inputProps = _props4.inputProps,
          onDayChange = _props4.onDayChange,
          parseDate = _props4.parseDate;

      if (inputProps.onChange) {
        e.persist();
        inputProps.onChange(e);
      }
      var value = e.target.value;

      if (value.trim() === '') {
        this.setState({ value: value });
        if (onDayChange) onDayChange(undefined, {});
        return;
      }
      var day = parseDate(value, format, dayPickerProps.locale);
      if (!day) {
        this.setState({ value: value });
        if (onDayChange) onDayChange(undefined, {});
        return;
      }
      this.updateState(day, value);
    }
  }, {
    key: 'handleInputKeyDown',
    value: function handleInputKeyDown(e) {
      if (e.keyCode === _keys.TAB) {
        this.hideDayPicker();
      } else {
        this.showDayPicker();
      }
      if (this.props.inputProps.onKeyDown) {
        e.persist();
        this.props.inputProps.onKeyDown(e);
      }
    }
  }, {
    key: 'handleInputKeyUp',
    value: function handleInputKeyUp(e) {
      if (e.keyCode === _keys.ESC) {
        this.hideDayPicker();
      } else {
        this.showDayPicker();
      }
      if (this.props.inputProps.onKeyUp) {
        e.persist();
        this.props.inputProps.onKeyUp(e);
      }
    }
  }, {
    key: 'handleMonthChange',
    value: function handleMonthChange(month) {
      var _this6 = this;

      this.setState({ month: month }, function () {
        if (_this6.props.dayPickerProps && _this6.props.dayPickerProps.onMonthChange) {
          _this6.props.dayPickerProps.onMonthChange(month);
        }
      });
    }
  }, {
    key: 'handleDayClick',
    value: function handleDayClick(day, modifiers, e) {
      var _this7 = this;

      var _props5 = this.props,
          clickUnselectsDay = _props5.clickUnselectsDay,
          dayPickerProps = _props5.dayPickerProps,
          onDayChange = _props5.onDayChange,
          formatDate = _props5.formatDate,
          format = _props5.format;

      if (dayPickerProps.onDayClick) {
        dayPickerProps.onDayClick(day, modifiers, e);
      }

      // Do nothing if the day is disabled
      if (modifiers.disabled) {
        return;
      }

      // If the clicked day is already selected, remove the clicked day
      // from the selected days and empty the field value
      if (modifiers.selected && clickUnselectsDay) {
        var selectedDays = this.state.selectedDays;

        if (Array.isArray(selectedDays)) {
          selectedDays = selectedDays.slice(0);
          var selectedDayIdx = selectedDays.indexOf(day);
          selectedDays.splice(selectedDayIdx, 1);
        } else if (selectedDays) {
          selectedDays = null;
        }
        this.setState({ value: '', selectedDays: selectedDays }, this.hideAfterDayClick);
        if (onDayChange) {
          onDayChange(undefined, modifiers);
        }
        return;
      }

      var value = formatDate(day, format, dayPickerProps.locale);
      this.setState({ value: value, month: day }, function () {
        if (onDayChange) {
          onDayChange(day, modifiers);
        }
        _this7.hideAfterDayClick();
      });
    }
  }, {
    key: 'renderOverlay',
    value: function renderOverlay() {
      var _this8 = this;

      var _props6 = this.props,
          classNames = _props6.classNames,
          dayPickerProps = _props6.dayPickerProps,
          parseDate = _props6.parseDate,
          formatDate = _props6.formatDate,
          format = _props6.format;
      var _state2 = this.state,
          selectedDays = _state2.selectedDays,
          value = _state2.value;

      var selectedDay = void 0;
      if (!selectedDays && value) {
        var day = parseDate(value, format, dayPickerProps.locale);
        if (day) {
          selectedDay = day;
        }
      } else if (selectedDays) {
        selectedDay = selectedDays;
      }
      var onTodayButtonClick = void 0;
      if (dayPickerProps.todayButton) {
        // Set the current day when clicking the today button
        onTodayButtonClick = function onTodayButtonClick() {
          return _this8.updateState(new Date(), formatDate(new Date(), format, dayPickerProps.locale), _this8.hideAfterDayClick);
        };
      }
      var Overlay = this.props.overlayComponent;
      return _react2.default.createElement(
        Overlay,
        {
          classNames: classNames,
          month: this.state.month,
          selectedDay: selectedDay,
          input: this.input,
          tabIndex: 0 // tabIndex is necessary to catch focus/blur events on Safari
          , onFocus: this.handleOverlayFocus,
          onBlur: this.handleOverlayBlur
        },
        _react2.default.createElement(_DayPicker2.default, _extends({
          ref: function ref(el) {
            return _this8.daypicker = el;
          },
          onTodayButtonClick: onTodayButtonClick
        }, dayPickerProps, {
          month: this.state.month,
          selectedDays: selectedDay,
          onDayClick: this.handleDayClick,
          onMonthChange: this.handleMonthChange
        }))
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var Input = this.props.component;
      var inputProps = this.props.inputProps;

      return _react2.default.createElement(
        'div',
        { className: this.props.classNames.container },
        _react2.default.createElement(Input, _extends({
          ref: function ref(el) {
            return _this9.input = el;
          },
          placeholder: this.props.placeholder
        }, inputProps, {
          value: this.state.value,
          onChange: this.handleInputChange,
          onFocus: this.handleInputFocus,
          onBlur: this.handleInputBlur,
          onKeyDown: this.handleInputKeyDown,
          onKeyUp: this.handleInputKeyUp,
          onClick: !inputProps.disabled ? this.handleInputClick : undefined
        })),
        this.state.showOverlay && this.renderOverlay()
      );
    }
  }]);

  return DayPickerInput;
}(_react2.default.Component);

DayPickerInput.defaultProps = {
  dayPickerProps: {},
  value: '',
  placeholder: 'YYYY-M-D',
  format: 'L',
  formatDate: defaultFormat,
  parseDate: defaultParse,
  showOverlay: false,
  hideOnDayClick: true,
  clickUnselectsDay: false,
  keepFocus: true,
  component: 'input',
  inputProps: {},
  overlayComponent: OverlayComponent,
  classNames: {
    container: 'DayPickerInput',
    overlayWrapper: 'DayPickerInput-OverlayWrapper',
    overlay: 'DayPickerInput-Overlay'
  }
};
exports.default = DayPickerInput;
DayPickerInput.propTypes =  false ? {
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
  inputProps: _propTypes2.default.object,
  placeholder: _propTypes2.default.string,

  format: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),

  formatDate: _propTypes2.default.func,
  parseDate: _propTypes2.default.func,

  showOverlay: _propTypes2.default.bool,
  dayPickerProps: _propTypes2.default.object,
  hideOnDayClick: _propTypes2.default.bool,
  clickUnselectsDay: _propTypes2.default.bool,
  keepFocus: _propTypes2.default.bool,
  component: _propTypes2.default.any,
  overlayComponent: _propTypes2.default.any,

  classNames: _propTypes2.default.shape({
    container: _propTypes2.default.string,
    overlayWrapper: _propTypes2.default.string,
    overlay: _propTypes2.default.string.isRequired
  }),

  onDayChange: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func
} : {};
//# sourceMappingURL=DayPickerInput.js.map

/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomSelectNullSafe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_index__ = __webpack_require__(5);
var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * Makes Select Boxes safe to objects with missing label. When Loading page we have Id but not name which is fetched
 * lazy, so we prevent update if id is know but name not
 */
var CustomSelectNullSafe = (_temp2 = _class = function (_React$Component) {
    _inherits(CustomSelectNullSafe, _React$Component);

    function CustomSelectNullSafe() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CustomSelectNullSafe);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CustomSelectNullSafe.__proto__ || Object.getPrototypeOf(CustomSelectNullSafe)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = function (newProps) {
            // Dont re-render if we have a label and want to update to empty string
            if (_this.props.value && _this.props.value[_this.props.labelKey] !== "" && newProps.value && newProps.value[newProps.labelKey] === "") {
                return false;
            }
            // Dont re-render if value is the same, both cases are null for example
            if (_this.props.value === newProps.value) {
                return false;
            }
            return true;
        }, _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_index__["b" /* CustomSelect */], {
                async: true, debounceTime: _this.props.debounceTime,
                "aria-label": _this.props.ariaLabel,
                placeholder: _this.props.placeholder,
                value: _this.props.value,
                onChange: _this.props.onChange,
                loadOptions: _this.props.loadOptions,
                valueKey: _this.props.valueKey,
                labelKey: _this.props.labelKey,
                minimumInput: _this.props.minimumInput,
                noResultsText: _this.props.noResultsText,
                searchPromptText: _this.props.searchPromptText,
                searchingText: _this.props.searchingText
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return CustomSelectNullSafe;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    multi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    async: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    debounceTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    loadOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    noResultsText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    searchPromptText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    searchingText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
}, _class.defaultProps = {
    options: []
}, _temp2);


/***/ }),

/***/ 1546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchInputField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_Svg__ = __webpack_require__(7);
var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SearchInputField = (_temp2 = _class = function (_React$Component) {
    _inherits(SearchInputField, _React$Component);

    function SearchInputField() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchInputField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchInputField.__proto__ || Object.getPrototypeOf(SearchInputField)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "mywort-box mywort-box--sm mywort-box--white" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "mywort-box__body" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "input-lined input-lined--keep-label" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "form",
                            { onSubmit: function onSubmit() {
                                    return _this.props.onChangeQuery(_this.props.query);
                                }, style: { 'margin': 0 } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                ref: function ref(input) {
                                    _this.queryInput = input;
                                },
                                type: "search",
                                id: "search-field",
                                value: _this.props.query,
                                onChange: _this.props.onChangeQuery,
                                required: true }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "input-lined__bar" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "label",
                                { className: "input-lined__label" },
                                __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].translate("public.search") + '...'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "button",
                                { type: "submit", className: "input-lined__icon" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__svg_Svg__["a" /* default */], { id: "search", className: "input-lined__icon__svg" })
                            )
                        )
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return SearchInputField;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    onChangeQuery: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class.defaultProps = {
    query: "",
    onChangeQuery: function onChangeQuery() {}
}, _temp2);


/***/ }),

/***/ 1547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}

/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @fileOverview Find scroll parent
 */

exports.default = function (node) {
  if (!node) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/***/ }),

/***/ 1550:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(744);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component) {
      _inherits(LazyLoadDecorated, _Component);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            _index2.default,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(_react.Component);
  };
};

/***/ }),

/***/ 1552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchMobilePage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchTypes__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CollapsibleFilterBox__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MobileSearchFilters__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_SearchTitle__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_SearchPostList__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_Svg__ = __webpack_require__(7);
var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SearchMobilePage = (_temp2 = _class = function (_React$Component) {
    _inherits(SearchMobilePage, _React$Component);

    function SearchMobilePage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchMobilePage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchMobilePage.__proto__ || Object.getPrototypeOf(SearchMobilePage)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "section" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "pure-g row--expanded" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "pure-u-1" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "mywort-box  mywort-box--white mywort-box--sm" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "div",
                                    { className: "mywort-box__body" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "div",
                                        { className: "u-m-v-b" },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "div",
                                            { className: "input-lined input-lined--keep-label" },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                "form",
                                                { onSubmit: function onSubmit(ev) {
                                                        return _this.props.onSubmit(ev, _this.queryInput);
                                                    } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                                                    ref: function ref(input) {
                                                        _this.queryInput = input;
                                                    },
                                                    type: "search",
                                                    id: "search-field",
                                                    value: _this.props.query,
                                                    onChange: _this.props.onChangeQuery,
                                                    required: true }),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "input-lined__bar" }),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "label",
                                                    { className: "input-lined__label" },
                                                    __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].translate("public.search") + '...'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    "button",
                                                    { type: "submit", className: "input-lined__icon" },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__svg_Svg__["a" /* default */], { id: "search", className: "input-lined__icon__svg" })
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SearchTypes__["a" /* default */], {
                                types: _this.props.types,
                                selected: _this.props.contentType,
                                query: _this.props.currentQueryObject,
                                className: "mywort-section-navigation--compact",
                                itemClassName: "mywort-section-navigation__entry--half"
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4__CollapsibleFilterBox__["a" /* default */],
                            {
                                title: __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].translate("search.filters.title"),
                                expanded: _this.props.locality || _this.props.group,
                                className: "mywort-collapse--compact mywort-collapse--light u-m-v" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "mywort-filters" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__MobileSearchFilters__["a" /* default */], {
                                    comingFrom: _this.props.comingFrom,
                                    query: _this.props.query,
                                    onChangeQuery: _this.props.onChangeQuery,
                                    contentType: _this.props.contentType,
                                    locality: _this.props.locality,
                                    searchLocality: _this.props.searchLocality,
                                    onChangeLocality: _this.props.onChangeLocality,
                                    group: _this.props.group,
                                    searchGroup: _this.props.searchGroup,
                                    onChangeGroup: _this.props.onChangeGroup,
                                    eventDate: _this.props.eventDate,
                                    onChangeEventDate: _this.props.onChangeEventDate,
                                    surroundings: _this.props.surroundings,
                                    onChangeSurroundings: _this.props.onChangeSurroundings,
                                    onResetFilters: _this.props.onResetFilters,
                                    language: _this.props.language,
                                    onChangeLanguage: _this.props.onChangeLanguage
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_SearchTitle__["a" /* default */], {
                            comingFrom: _this.props.comingFrom,
                            query: _this.props.query
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "section",
                            { className: "mywort-teaser-list" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_SearchPostList__["a" /* default */], {
                                results: _this.props.results,
                                loading: _this.props.loading,
                                onResetFilters: _this.props.onResetFilters
                            })
                        )
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return SearchMobilePage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.propTypes = {
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    onChangeQuery: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    types: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    contentTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    onChangeContentType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    locality: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    searchLocality: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onChangeLocality: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    group: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    searchGroup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onChangeGroup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onSetGroup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onSetLocality: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    eventDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    onChangeEventDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    surroundings: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    onChangeSurroundings: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    currentQueryObject: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    resultsLocalities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    resultsGroups: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    onResetFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    language: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    onChangeLanguage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _temp2);


/***/ }),

/***/ 1553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(53);


var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var SearchTypes = (_temp2 = _class = function (_React$Component) {
    _inherits(SearchTypes, _React$Component);

    function SearchTypes() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchTypes);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchTypes.__proto__ || Object.getPrototypeOf(SearchTypes)).call.apply(_ref, [this].concat(args))), _this), _this.renderType = function (type) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],
                { key: type.value, className: "mywort-btn mywort-btn--radius " + (_this.props.selected === type.value ? 'mywort-btn--switch-on' : 'mywort-btn--switch-off'), to: { pathname: "/", query: __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default()({ "type": type.value }, _this.props.query[type.value]) } },
                type.label
            );
        }, _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "mywort-btn-group mywort-btn-group--switch", "data-role": "group", "data-aria-label": "Button Group" },
                _this.props.types.map(function (type) {
                    return _this.renderType(type);
                })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return SearchTypes;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.propTypes = {
    types: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    query: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    selected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
}, _temp2);


/***/ }),

/***/ 1554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapsibleFilterBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_Svg__ = __webpack_require__(7);
var _class, _temp, _initialiseProps;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var CollapsibleFilterBox = (_temp = _class = function (_React$Component) {
    _inherits(CollapsibleFilterBox, _React$Component);

    function CollapsibleFilterBox(props) {
        _classCallCheck(this, CollapsibleFilterBox);

        var _this = _possibleConstructorReturn(this, (CollapsibleFilterBox.__proto__ || Object.getPrototypeOf(CollapsibleFilterBox)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = _this.initialState(props);
        return _this;
    }

    return CollapsibleFilterBox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.initialState = function (props) {
        return {
            expanded: props.expanded
        };
    };

    this.onToggle = function () {
        _this2.setState({
            expanded: !_this2.state.expanded
        });
    };

    this.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'mywort-collapse ' + _this2.props.className + ' ' + (_this2.state.expanded ? 'mywort-collapse--expanded' : '') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'mywort-collapse__header', onClick: _this2.onToggle },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'mywort-collapse__title' },
                    _this2.props.title
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__svg_Svg__["a" /* default */], { id: 'icon-chevron-down', className: 'mywort-collapse__chevron' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'mywort-collapse__content' },
                _this2.props.children
            )
        );
    };
}, _temp);


/***/ }),

/***/ 1555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileSearchFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_i18n_Translation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_index__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configurations_Constants__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_Svg__ = __webpack_require__(7);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var MobileSearchFilters = function (_React$Component) {
    _inherits(MobileSearchFilters, _React$Component);

    function MobileSearchFilters(props) {
        _classCallCheck(this, MobileSearchFilters);

        var _this = _possibleConstructorReturn(this, (MobileSearchFilters.__proto__ || Object.getPrototypeOf(MobileSearchFilters)).call(this, props));

        _this.isEvent = function () {
            return _this.props.contentType === __WEBPACK_IMPORTED_MODULE_4__configurations_Constants__["a" /* default */].CONTENT_FILTER.EVENT;
        };

        _this.onResetFilters = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.props.onResetFilters();
        };

        _this.renderLocality = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "mywort-filters__group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "mywort-filters__input" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_index__["b" /* CustomSelect */], {
                        searchPromptText: __WEBPACK_IMPORTED_MODULE_1__commons_i18n_Translation__["a" /* default */].translate("search.starttyping"),
                        searchingText: __WEBPACK_IMPORTED_MODULE_1__commons_i18n_Translation__["a" /* default */].translate("search.loading"),
                        async: true, debounceTime: 500,
                        placeholder: __WEBPACK_IMPORTED_MODULE_1__commons_i18n_Translation__["a" /* default */].translate("commons.locality"),
                        value: _this.props.locality,
                        onChange: _this.props.onChangeLocality,
                        loadOptions: function loadOptions(input, asyncSelectCallback) {
                            return _this.props.searchLocality(input, asyncSelectCallback);
                        },
                        valueKey: "id",
                        labelKey: "name",
                        minimumInput: 2
                    })
                )
            );
        };

        _this.renderGroup = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "mywort-filters__group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "mywort-filters__input" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commons_index__["b" /* CustomSelect */], {
                        searchPromptText: __WEBPACK_IMPORTED_MODULE_1__commons_i18n_Translation__["a" /* default */].translate("search.starttyping"),
                        searchingText: __WEBPACK_IMPORTED_MODULE_1__commons_i18n_Translation__["a" /* default */].translate("search.loading"),
                        async: true, debounceTime: 500,
                        placeholder: __WEBPACK_IMPORTED_MODULE_1__commons_i18n_Translation__["a" /* default */].translate("commons.group"),
                        value: _this.props.group,
                        onChange: _this.props.onChangeGroup,
                        loadOptions: function loadOptions(input, asyncSelectCallback) {
                            return _this.props.searchGroup(input, asyncSelectCallback);
                        },
                        valueKey: "id",
                        labelKey: "name",
                        minimumInput: 2
                    })
                )
            );
        };

        _this.renderEventDate = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "mywort-filters__group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "input-group date " },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "date",
                        defaultValue: _this.props.eventDate,
                        onChange: _this.props.onChangeEventDate,
                        className: "mywort-filters__input",
                        placeholder: __WEBPACK_IMPORTED_MODULE_1__commons_i18n_Translation__["a" /* default */].translate("search.filters.date.placeholder") }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "span",
                        { className: "input-group-addon" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_Svg__["a" /* default */], { id: "fa-calendar", className: "mywort-filters__group__svg" })
                    )
                )
            );
        };

        _this.renderLanguage = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "mywort-filters__group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "mywort-filters__input" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["default"], {
                        "aria-label": __WEBPACK_IMPORTED_MODULE_1__commons_i18n_Translation__["a" /* default */].translate("commons.language"),
                        placeholder: __WEBPACK_IMPORTED_MODULE_1__commons_i18n_Translation__["a" /* default */].translate("commons.language"),
                        value: _this.props.language,
                        onChange: _this.props.onChangeLanguage,
                        options: __WEBPACK_IMPORTED_MODULE_2__commons_index__["a" /* CommonsConstants */].LANGUAGES,
                        valueKey: "id",
                        labelKey: "name",
                        searchable: false,
                        clearable: true
                    })
                )
            );
        };

        _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "mywort-filters" },
                _this.isEvent() ? _this.renderEventDate() : null,
                _this.renderLocality(),
                _this.renderGroup(),
                _this.renderLanguage(),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "mywort-filters__section u-text-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "a",
                        { href: "", className: "mywort-filters__reset-filters mywort-link mywort-link--gray", onClick: _this.onResetFilters },
                        __WEBPACK_IMPORTED_MODULE_1__commons_i18n_Translation__["a" /* default */].translate("search.filters.reset")
                    )
                )
            );
        };

        return _this;
    }

    return MobileSearchFilters;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);



/***/ }),

/***/ 1556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LandingTabs; });
/* unused harmony export LandingTabsPresenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sp_react_commons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sp_react_commons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sp_react_commons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_PostActions__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LatestPosts__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__ = __webpack_require__(14);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











/**
 * MyWort home page section 2 tabs for switching between News and Events.
 *
 *
 */
var LandingTabs = function (_RefluxComponent) {
    _inherits(LandingTabs, _RefluxComponent);

    function LandingTabs(props) {
        _classCallCheck(this, LandingTabs);

        var _this = _possibleConstructorReturn(this, (LandingTabs.__proto__ || Object.getPrototypeOf(LandingTabs)).call(this, props));

        _this.getInitialState = function () {
            var activeTab = _this.props.activeTab || 'post';
            if (_this.props.activeTab !== 'post' && _this.props.activeTab !== 'event' && _this.props.activeTab !== 'locality' && _this.props.activeTab !== 'group') {
                activeTab = 'post';
            }
            return {
                activeTab: activeTab,
                posts: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].posts,
                events: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].events,
                localities: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].localities,
                groups: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].groups,
                remainingPosts: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].remainingPosts,
                remainingEvents: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].remainingEvents,
                remainingGroups: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].remainingGroups,
                remainingLocalities: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].remainingLocalities
            };
        };

        _this.onStoreChange = function () {
            _this.setState({
                posts: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].posts,
                events: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].events,
                localities: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].localities,
                groups: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].groups,
                remainingPosts: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].remainingPosts,
                remainingEvents: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].remainingEvents,
                remainingGroups: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].remainingGroups,
                remainingLocalities: __WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */].remainingLocalities
            });
        };

        _this.switchToTab = function (e, tab) {
            e.preventDefault();
            e.stopPropagation();
            _this.setState({
                activeTab: tab
            });
            history.pushState({}, document.title, _this.updateQueryStringParam("activeTab", tab));
        };

        _this.getActiveTab = function () {
            return _this.state.activeTab;
        };

        _this.onClickMoreEvents = function () {
            __WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getMoreEvents();
        };

        _this.onClickMorePosts = function () {
            __WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getMorePost();
        };

        _this.onClickMoreGroups = function () {
            __WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getMoreGroups();
        };

        _this.onClickMoreLocalities = function () {
            __WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getMoreLocalities();
        };

        _this.onRedirectToSearch = function () {
            if (_this.state.activeTab === 'locality' || 'group') window.location = '/' + __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].getLanguageName() + '/mywort/search';else window.location = '/' + __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].getLanguageName() + '/mywort/search#/?type=' + _this.state.activeTab;
        };

        _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LandingTabsPresenter, {
                activeTab: _this.getActiveTab(),
                posts: _this.state.posts,
                events: _this.state.events,
                localities: _this.state.localities,
                groups: _this.state.groups,
                switchToTab: _this.switchToTab,
                canLoadMorePosts: _this.state.remainingPosts > 0,
                onLoadMorePosts: _this.onClickMorePosts,
                canLoadMoreEvents: _this.state.remainingEvents > 0,
                onLoadMoreEvents: _this.onClickMoreEvents,
                canLoadMoreGroups: _this.state.remainingGroups > 0,
                onLoadMoreGroups: _this.onClickMoreGroups,
                canLoadMoreLocalities: _this.state.remainingLocalities > 0,
                onLoadMoreLocalities: _this.onClickMoreLocalities,
                onRedirectToSearch: _this.onRedirectToSearch
            });
        };

        _this.state = _this.getInitialState(props);
        return _this;
    }

    _createClass(LandingTabs, [{
        key: "updateQueryStringParam",
        value: function updateQueryStringParam(key, value) {
            var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
                urlQueryString = document.location.search,
                newParam = key + '=' + value,
                params = '?' + newParam;

            if (urlQueryString) {
                var keyRegex = new RegExp('([\?&])' + key + '[^&]*');
                if (urlQueryString.match(keyRegex) !== null) {
                    params = urlQueryString.replace(keyRegex, "$1" + newParam);
                } else {
                    params = urlQueryString + '&' + newParam;
                }
            }
            return baseUrl + params;
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.listenTo(__WEBPACK_IMPORTED_MODULE_4__stores_PostStore__["a" /* default */], this.onStoreChange);
        }
    }]);

    return LandingTabs;
}(__WEBPACK_IMPORTED_MODULE_2_sp_react_commons__["RefluxComponent"]);

var LandingTabsPresenter = function (_React$Component) {
    _inherits(LandingTabsPresenter, _React$Component);

    function LandingTabsPresenter() {
        var _ref;

        var _temp, _this2, _ret;

        _classCallCheck(this, LandingTabsPresenter);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = LandingTabsPresenter.__proto__ || Object.getPrototypeOf(LandingTabsPresenter)).call.apply(_ref, [this].concat(args))), _this2), _this2.renderTab = function (tabName) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("mywort-section-navigation__entry", { "mywort-section-navigation__entry--active": _this2.props.activeTab === tabName }) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "a",
                    { href: "#", onClick: function onClick(e) {
                            return _this2.props.switchToTab(e, tabName);
                        } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h2",
                        { className: "mywort-section-navigation__inherit" },
                        __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("landing.tabs." + tabName + "s")
                    )
                )
            );
        }, _this2.renderInfoBox = function (tabName) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "pure-u-1 mywort-info-box" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "mywort-info-box__message" },
                    __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("landing.info-box." + tabName + "-message")
                )
            );
        }, _this2.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "section__header" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "ul",
                        { className: "mywort-section-navigation" },
                        _this2.renderTab("post"),
                        _this2.renderTab("event"),
                        _this2.props.localities.length > 0 ? _this2.renderTab("locality") : null,
                        _this2.props.groups.length > 0 ? _this2.renderTab("group") : null
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { id: "mywort-react-posts", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ "hide": _this2.props.activeTab !== 'post' }) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LatestPosts__["a" /* default */], {
                        elements: _this2.props.posts,
                        canShowMore: _this2.props.canLoadMorePosts,
                        onClickMore: _this2.props.onLoadMorePosts,
                        onClickSearch: _this2.props.onRedirectToSearch })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { id: "mywort-react-events", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ "hide": _this2.props.activeTab !== 'event' }) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LatestPosts__["a" /* default */], {
                        elements: _this2.props.events,
                        canShowMore: _this2.props.canLoadMoreEvents,
                        onClickMore: _this2.props.onLoadMoreEvents,
                        onClickSearch: _this2.props.onRedirectToSearch })
                ),
                _this2.props.localities.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { id: "mywort-react-localities", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("pure-g pure-g--gutters-mywort card-block", { "hide": _this2.props.activeTab !== 'locality' }) },
                    _this2.renderInfoBox('locality'),
                    _this2.props.localities.map(function (locality) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { className: "card-block__column pure-u-1 pure-u-lg-12-24 pure-u-md-24-24", key: locality.id },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "article",
                                { className: "mywort-post mywort-post--full-condensed" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "div",
                                    { className: "mywort-post__locality__container" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "div",
                                        { className: "mywort-post__title-inside mywort-post__title-inside--locality" },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "a",
                                            { className: "mywort-post__title-inside__locality-name", href: locality.permalink },
                                            locality.name
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "div",
                                            { className: "mywort-post__title-inside__municipality" },
                                            locality.name !== locality.municipality ? __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("search.filters.municipality") + " " + locality.municipality : null
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "a",
                                        { className: "mywort-post__picture-wrapper mywort-post__link mywort-post__picture-wrapper--locality", href: locality.permalink },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: "mywort-post-localities__img", src: locality.pictureUrl })
                                    )
                                )
                            )
                        );
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "pure-u-1 card-block__row card-block__row--center" },
                        _this2.props.canLoadMoreLocalities ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "button",
                            { id: "mywort-btn mywort-btn__locality__more", className: "mywort-btn mywort-btn__locality u-mr-h", onClick: _this2.props.onLoadMoreLocalities },
                            __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("public.more")
                        ) : null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "button",
                            { id: "mywort-btn mywort-btn__locality__search", className: "mywort-btn mywort-btn__locality mywort-btn--outlined-orange", onClick: _this2.props.onRedirectToSearch },
                            __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("public.search")
                        )
                    )
                ) : null,
                _this2.props.groups.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { id: "mywort-react-groups", className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("pure-g pure-g--gutters-mywort card-block", { "hide": _this2.props.activeTab !== 'group' }) },
                    _this2.renderInfoBox('group'),
                    _this2.props.groups.map(function (group) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { className: "card-block__column pure-u-1 pure-u-lg-12-24 pure-u-md-24-24", key: group.name },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "article",
                                { className: "mywort-post mywort-post--full-condensed" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "div",
                                    { className: "mywort-post__locality__container" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "div",
                                        { className: "mywort-post__title-inside mywort-post__title-inside--group" },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "a",
                                            { className: "mywort-post__title-inside__group-name", href: group.permalink },
                                            group.name
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            "a",
                                            { className: "mywort-post__title-inside__municipality", href: group.localityPermalink },
                                            group.localityName
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "a",
                                        { className: "mywort-post__picture-wrapper mywort-post__link mywort-post__picture-wrapper--group", href: group.permalink },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: "mywort-post-group__img", src: group.pictureUrl })
                                    )
                                )
                            )
                        );
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "pure-u-1 card-block__row card-block__row--center" },
                        _this2.props.canLoadMoreGroups ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "button",
                            { id: "mywort-btn__group__more", className: "mywort-btn mywort-btn__group u-mr-h", onClick: _this2.props.onLoadMoreGroups },
                            __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("public.more")
                        ) : null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "button",
                            { id: "mywort-btn__group__search", className: "mywort-btn mywort-btn__group mywort-btn--outlined-orange", onClick: _this2.props.onRedirectToSearch },
                            __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("public.search")
                        )
                    )
                ) : null
            );
        }, _temp), _possibleConstructorReturn(_this2, _ret);
    }

    return LandingTabsPresenter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),

/***/ 1557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LatestPosts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_unescape__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_unescape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_unescape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reject__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_chunk__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_chunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_chunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FoundationComponents__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Post__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_i18n_Translation__ = __webpack_require__(14);




var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/**
 * MyWort home page section with X latest posts.
 *
 * A "more" button let the user display another X latest posts, ordered by date
 */
var LatestPosts = (_temp2 = _class = function (_React$Component) {
    _inherits(LatestPosts, _React$Component);

    function LatestPosts() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, LatestPosts);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LatestPosts.__proto__ || Object.getPrototypeOf(LatestPosts)).call.apply(_ref, [this].concat(args))), _this), _this.getLayoutFromPosts = function (posts) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash_reject___default()(posts, 'futureOccurrences').length >= 3 && __WEBPACK_IMPORTED_MODULE_1_lodash_reject___default()(posts, 'mwTeaserMedium').length >= 3 ? __WEBPACK_IMPORTED_MODULE_6__components_Post__["a" /* default */].LAYOUTS.SMALL : __WEBPACK_IMPORTED_MODULE_6__components_Post__["a" /* default */].LAYOUTS.DEFAULT;
        }, _this.renderPost = function (post) {
            var layout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_6__components_Post__["a" /* default */].LAYOUTS.DEFAULT;
            var teaserPicture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : post.mwTeaserMedium;
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Post__["a" /* default */], { postId: post.id,
                publisherAvatarUri: post.publisher.avatarUrl,
                publisherPermalink: post.publisher.publicPermalink,
                publisherName: __WEBPACK_IMPORTED_MODULE_0_lodash_unescape___default()(post.publisher.fullName),
                postTitle: __WEBPACK_IMPORTED_MODULE_0_lodash_unescape___default()(post.title),
                postPermalink: post.permaLink,
                postType: post.style,
                publishedAt: post.publishedAt,
                localityName: post.locality.name,
                localityPermalink: post.localityPermalink,
                teaserPicture: teaserPicture,
                videoThumbnail: post.videoThumbnail,
                nextOccurrence: post.nextOccurrence,
                isGroup: post.publisher.isGroup,
                layout: layout,
                randomGradient: post.randomGradient,
                maybeMissionId: post.maybeMissionId });
        }, _this.renderFirstRow = function (posts) {
            posts = posts.slice(0, 3);
            var layout = _this.getLayoutFromPosts(posts);
            return posts.map(function (post, idx) {
                return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "div",
                    { className: "card-block__column pure-u-1 pure-u-lg-8-24 " + (idx === 2 ? 'pure-u-md-24-24' : 'pure-u-md-12-24'), key: idx },
                    _this.renderPost(post, layout)
                );
            });
        }, _this.renderHighlighItemTwoX = function (posts) {
            posts = posts.slice(3, 5);

            var firsPost = posts[0];
            var secondPost = posts[1];
            var fullPost = void 0;

            if (firsPost) {
                if (secondPost && secondPost.mwTeaserLarge) {
                    fullPost = secondPost;
                } else {
                    fullPost = firsPost;
                }
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__components_FoundationComponents__["a" /* Col */],
                { className: "card-block__column pure-u-1 pure-u-md-24-24 pure-u-lg-16-24" },
                fullPost ? _this.renderPost(fullPost, __WEBPACK_IMPORTED_MODULE_6__components_Post__["a" /* default */].LAYOUTS.FULL, fullPost.mwTeaserLarge) : null
            );
        }, _this.renderHighlighItemOneX = function (posts) {
            posts = posts.slice(3, 5);

            var firsPost = posts[0];
            var secondPost = posts[1];
            var defaultPost = void 0;

            if (firsPost) {
                if (secondPost && secondPost.mwTeaserLarge) {
                    defaultPost = firsPost;
                } else if (secondPost) {
                    defaultPost = secondPost;
                }
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__components_FoundationComponents__["a" /* Col */],
                { className: "card-block__column pure-u-1 pure-u-md-24-24 pure-u-lg-8-24" },
                defaultPost ? _this.renderPost(defaultPost, __WEBPACK_IMPORTED_MODULE_6__components_Post__["a" /* default */].LAYOUTS.FULL) : null
            );
        }, _this.renderThirdRow = function (posts) {
            posts = posts.slice(5, 8);
            var layout = _this.getLayoutFromPosts(posts);

            return posts.map(function (post, idx) {
                return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5__components_FoundationComponents__["a" /* Col */],
                    { className: "card-block__column pure-u-lg-8-24 " + (idx === 2 ? 'pure-u-md-24-24' : 'pure-u-md-12-24'), key: idx },
                    _this.renderPost(post, layout)
                );
            });
        }, _this.renderFourthRow = function (posts) {
            posts = posts.slice(8, 11);
            var layout = _this.getLayoutFromPosts(posts);

            return posts.map(function (post, idx) {
                return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5__components_FoundationComponents__["a" /* Col */],
                    { className: "card-block__column pure-u-lg-8-24 " + (idx === 2 ? 'pure-u-md-24-24' : 'pure-u-md-12-24'), key: post.id },
                    _this.renderPost(post, layout)
                );
            });
        }, _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                "div",
                { className: "card-block" },
                __WEBPACK_IMPORTED_MODULE_2_lodash_chunk___default()(_this.props.elements, 11).map(function (posts, idx) {
                    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        "div",
                        { className: "pure-g pure-g--gutters-mywort card-block__row card-block__row--internal", key: idx },
                        _this.renderFirstRow(posts),
                        _this.renderHighlighItemTwoX(posts),
                        _this.renderHighlighItemOneX(posts),
                        _this.renderThirdRow(posts),
                        _this.renderFourthRow(posts)
                    );
                }),
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    "div",
                    { className: "card-block__row card-block__row--center" },
                    _this.props.canShowMore ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        "button",
                        { className: "mywort-btn  u-mr-h", onClick: _this.props.onClickMore },
                        __WEBPACK_IMPORTED_MODULE_7__commons_i18n_Translation__["a" /* default */].translate("public.more")
                    ) : null,
                    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                        "button",
                        { className: "mywort-btn mywort-btn--outlined-orange", onClick: _this.props.onClickSearch },
                        __WEBPACK_IMPORTED_MODULE_7__commons_i18n_Translation__["a" /* default */].translate("public.search")
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    // Display smaller posts if there are minimum 2 posts without picture


    return LatestPosts;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.defaultProps = {
    elements: []
}, _class.propTypes = {
    elements: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
    canShowMore: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    onClickMore: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    onClickSearch: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
}, _temp2);


/***/ }),

/***/ 1564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupDetailsModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_split__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_last__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_components_MywortModalWrapper__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_lib_Modal__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_utils_StringUtils__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_Api__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons__ = __webpack_require__(5);



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var GroupDetailsModal = function (_React$Component) {
    _inherits(GroupDetailsModal, _React$Component);

    function GroupDetailsModal(props) {
        _classCallCheck(this, GroupDetailsModal);

        var _this = _possibleConstructorReturn(this, (GroupDetailsModal.__proto__ || Object.getPrototypeOf(GroupDetailsModal)).call(this, props));

        _this.initialState = function () {
            return {
                showModal: false,
                group: undefined
            };
        };

        _this.getGroup = function () {
            var groupId = __WEBPACK_IMPORTED_MODULE_1_lodash_last___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_split___default()(window.location.href, "/"));
            __WEBPACK_IMPORTED_MODULE_6__api_Api__["a" /* GroupApi */].getGroup(groupId).then(function (group) {
                _this.setState({
                    group: group,
                    showModal: true
                });
            });
        };

        _this.showModal = function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (!_this.state.group) _this.getGroup();else _this.setState({ showModal: true });
        };

        _this.hideModal = function () {
            return _this.setState({ showModal: false });
        };

        _this.renderModal = function () {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__commons_components_MywortModalWrapper__["a" /* default */],
                { show: true, onHide: _this.hideModal, backdrop: true },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_lib_Modal___default.a.Header,
                    { className: "mywort-modal__header", closeButton: true },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_lib_Modal___default.a.Title,
                        { className: "mywort-modal__title" },
                        _this.state.group.name
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        "p",
                        { className: "group-details-modal__locality" },
                        _this.state.group.locality
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_lib_Modal___default.a.Body,
                    { className: "group-details-modal__body" },
                    _this.state.group.mainPicture ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img", { src: _this.state.group.mainPicture.thumbnail, alt: _this.state.group.name }) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { className: "group-details-modal__no-picture" }),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        "div",
                        { className: "group-details-modal__description" },
                        __WEBPACK_IMPORTED_MODULE_5__commons_utils_StringUtils__["a" /* default */].withLineBreakAsHtml(_this.state.group.description)
                    )
                )
            );
        };

        _this.renderReadMoreButton = function () {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                "a",
                { href: "", className: "group-details-modal__read-more-button u-text-underline", onClick: _this.showModal },
                __WEBPACK_IMPORTED_MODULE_7__commons__["l" /* Translation */].translate("commons.about")
            );
        };

        _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                "div",
                null,
                _this.renderReadMoreButton(),
                _this.state.showModal ? _this.renderModal() : null
            );
        };

        _this.state = _this.initialState();
        return _this;
    }

    return GroupDetailsModal;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);



/***/ }),

/***/ 1565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserModule__ = __webpack_require__(1566);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__UserModule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserPostList__ = __webpack_require__(752);
/* unused harmony reexport UserPostList */





/***/ }),

/***/ 1566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sp_react_commons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sp_react_commons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sp_react_commons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_Api__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserPostList__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AppConfig__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_AppConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_AppConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_Svg__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_mywort_mywort_logo_negative_png__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_mywort_mywort_logo_negative_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_mywort_mywort_logo_negative_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_usermodule_01_gif__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_usermodule_01_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_usermodule_01_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_usermodule_01_2x_gif__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_usermodule_01_2x_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_usermodule_01_2x_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_usermodule_02_gif__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_usermodule_02_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_usermodule_02_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_usermodule_02_2x_gif__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_usermodule_02_2x_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_usermodule_02_2x_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_usermodule_03_gif__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_usermodule_03_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_usermodule_03_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_usermodule_03_2x_gif__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_usermodule_03_2x_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_usermodule_03_2x_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_loader_medium_gif__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_loader_medium_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_loader_medium_gif__);
var _class5, _temp5;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var MyWortRegister = function (_React$Component) {
    _inherits(MyWortRegister, _React$Component);

    function MyWortRegister() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, MyWortRegister);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MyWortRegister.__proto__ || Object.getPrototypeOf(MyWortRegister)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "user-module__main" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "user-module__no-access" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "user-module__no-access__name" },
                        __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.hi"),
                        " ",
                        _this.props.user.firstName,
                        ","
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "user-module__no-access__sub" },
                        __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.expect")
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "user-module__no-access__text" },
                        __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.take-a-look")
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "a",
                        { href: "/" + __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].getLanguageName() + "/mywort/edit#/post/create", className: "mywort-btn mywort-btn--orange mywort-btn--large user-module__no-access-btn" },
                        __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.create-first")
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "user-module__no-access__footer" },
                        __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.create-text-footer")
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return MyWortRegister;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var MyWortBlocked = function (_React$Component2) {
    _inherits(MyWortBlocked, _React$Component2);

    function MyWortBlocked() {
        var _ref2;

        var _temp2, _this2, _ret2;

        _classCallCheck(this, MyWortBlocked);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = MyWortBlocked.__proto__ || Object.getPrototypeOf(MyWortBlocked)).call.apply(_ref2, [this].concat(args))), _this2), _this2.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "user-module__main" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "user-module__no-access" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "user-module__no-access__name" },
                        __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.you-are-blocked")
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "user-module__no-access__text" },
                        __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.contact-admin")
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "user-module__no-access__email" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "a",
                            { href: "mailto:" + __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.contact-email") },
                            __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.contact-email")
                        ),
                        " "
                    )
                )
            );
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    return MyWortBlocked;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var LoginAndRegister = function (_React$Component3) {
    _inherits(LoginAndRegister, _React$Component3);

    function LoginAndRegister() {
        var _ref3;

        var _temp3, _this3, _ret3;

        _classCallCheck(this, LoginAndRegister);

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref3 = LoginAndRegister.__proto__ || Object.getPrototypeOf(LoginAndRegister)).call.apply(_ref3, [this].concat(args))), _this3), _this3.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "user-module-container" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "user-module__subtitle" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_9__images_mywort_mywort_logo_negative_png___default.a })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "user-module__switcher" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { id: "owl-user-module", className: "owl-carousel" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { className: "switcher-content" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "switcher-content__icon" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_10__images_usermodule_01_gif___default.a, srcSet: __WEBPACK_IMPORTED_MODULE_10__images_usermodule_01_gif___default.a + " 1x, " + __WEBPACK_IMPORTED_MODULE_11__images_usermodule_01_2x_gif___default.a + " 2x" })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "switcher-text" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "div",
                                    { className: "switcher-text__title" },
                                    __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.carousel-title-1")
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "div",
                                    { className: "switcher-text__desc" },
                                    __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.carousel-sub-1")
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { className: "switcher-content" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "switcher-content__icon" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_12__images_usermodule_02_gif___default.a, srcSet: __WEBPACK_IMPORTED_MODULE_12__images_usermodule_02_gif___default.a + " 1x, " + __WEBPACK_IMPORTED_MODULE_13__images_usermodule_02_2x_gif___default.a + " 2x" })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "switcher-text" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "div",
                                    { className: "switcher-text__title" },
                                    __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.carousel-title-2")
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "div",
                                    { className: "switcher-text__desc" },
                                    __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.carousel-sub-2"),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        "div",
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.carousel-sub-2-1")
                                    )
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { className: "switcher-content" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "switcher-content__icon" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_14__images_usermodule_03_gif___default.a, srcSet: __WEBPACK_IMPORTED_MODULE_14__images_usermodule_03_gif___default.a + " 1x, " + __WEBPACK_IMPORTED_MODULE_15__images_usermodule_03_2x_gif___default.a + " 2x" })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "switcher-text" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "div",
                                    { className: "switcher-text__title" },
                                    __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.carousel-title-3")
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "div",
                                    { className: "switcher-text__desc" },
                                    __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.carousel-sub-3")
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "user-module-container__btn" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "a",
                        { href: __WEBPACK_IMPORTED_MODULE_7_AppConfig___default.a.mywortWebHost + "/oauth/login?lang=" + __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].getLanguageName() + "&referrer=/" + __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].getLanguageName() + "/mywort/edit#/post/create", className: "mywort-btn mywort-btn--large mywort-btn--invert-orange" },
                        __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.carousel-title-5")
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "user-module-container__member-connect" },
                    __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.already-member?"),
                    "\xA0",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "a",
                        { href: __WEBPACK_IMPORTED_MODULE_7_AppConfig___default.a.mywortWebHost + "/oauth/login?lang=" + __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].getLanguageName() + "&referrer=" + window.location.pathname, className: "u-text-underline" },
                        __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.connect")
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "a",
                        { href: "/" + __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].getLanguageName() + "/mywort/faq", className: "u-text-underline" },
                        "FAQ"
                    )
                )
            );
        }, _temp3), _possibleConstructorReturn(_this3, _ret3);
    }

    _createClass(LoginAndRegister, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            $("#owl-user-module").owlCarousel({
                items: 1,
                slideBy: 1,
                smartSpeed: 400,
                dotsSpeed: 300,
                autoHeight: true, // Not documented in Owl carousel docs, but seems to fix wrong calculated height issue
                autoplay: true,
                autoplayTimeout: 7000,
                rewind: true,
                center: true
            });
        }
    }]);

    return LoginAndRegister;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var MyWortAccess = function (_RefluxComponent) {
    _inherits(MyWortAccess, _RefluxComponent);

    function MyWortAccess() {
        var _ref4;

        var _temp4, _this4, _ret4;

        _classCallCheck(this, MyWortAccess);

        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        return _ret4 = (_temp4 = (_this4 = _possibleConstructorReturn(this, (_ref4 = MyWortAccess.__proto__ || Object.getPrototypeOf(MyWortAccess)).call.apply(_ref4, [this].concat(args))), _this4), _this4.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "user-module__main" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "user-module__latest" },
                    __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.latest-posts")
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "user-module__section" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__UserPostList__["a" /* default */], { posts: _this4.props.posts, totalPostsCount: _this4.props.totalPostsCount })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "user-module__actions" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "a",
                        { href: "/" + __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].getLanguageName() + "/mywort/edit#/post/create", className: "mywort-btn mywort-btn--orange mywort-btn--large user-module__custom_btn" },
                        __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.add-post")
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "user-module__double" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "a",
                        { href: "/" + __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].getLanguageName() + "/mywort/edit#/post" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { className: "pure-u-1 pure-u-lg-12-24 user-module__left u-hover-primary-color" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "user-module__icon" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__svg_Svg__["a" /* default */], { id: "fa-file-text", className: "user-module__icon__svg" })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "user-module__label", dangerouslySetInnerHTML: { __html: __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.manage-posts") } })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "a",
                        { href: "/" + __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].getLanguageName() + "/mywort/edit#/group" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { className: "pure-u-1 pure-u-sm-12-24 user-module__right u-hover-primary-color" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                { className: "user-module__icon" },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__svg_Svg__["a" /* default */], { id: "fa-users", className: "user-module__icon__svg" })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "user-module__label", dangerouslySetInnerHTML: { __html: __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.manage-groups") } })
                        )
                    )
                )
            );
        }, _temp4), _possibleConstructorReturn(_this4, _ret4);
    }

    return MyWortAccess;
}(__WEBPACK_IMPORTED_MODULE_2_sp_react_commons__["RefluxComponent"]);

var UserModule = (_temp5 = _class5 = function (_RefluxComponent2) {
    _inherits(UserModule, _RefluxComponent2);

    function UserModule() {
        _classCallCheck(this, UserModule);

        var _this5 = _possibleConstructorReturn(this, (UserModule.__proto__ || Object.getPrototypeOf(UserModule)).call(this));

        _this5.initialState = function () {
            return {
                loading: true,
                user: undefined,
                posts: []
            };
        };

        _this5._onStoreChange = function (data) {
            _this5.setState({
                loading: false,
                user: data.user
            });
            // Get user's posts if user has access to MyWort
            if (_this5.state.posts.length === 0 && data.user && data.user.myWortAccess) {
                _this5._loadUserPosts();
            }
        };

        _this5._loadUserPosts = function () {
            __WEBPACK_IMPORTED_MODULE_4__api_Api__["d" /* UserApi */].getUserPosts().then(function (data) {
                _this5.setState({
                    posts: data.posts,
                    totalPostsCount: data.total
                });
            });
        };

        _this5.addPost = function () {
            return window.location = "/" + __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].getLanguageName() + "/mywort/edit#/post";
        };

        _this5.renderLoggedUserModule = function () {
            var mainModule = void 0;

            if (_this5.state.user.myWortAccess === true) {
                mainModule = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyWortAccess, { posts: _this5.state.posts });
            } else if (_this5.state.user.myWortAccess === false) {
                mainModule = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyWortBlocked, { user: _this5.state.user });
            } else {
                mainModule = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyWortRegister, { user: _this5.state.user });
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "user-module" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "user-module__orange-header" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "user-module__user-info-header" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commons__["n" /* UserAvatarPresenter */], { user: _this5.state.user, className: "user-module__avatar" }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "user-module__info" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { className: "user-module__name" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "a",
                                { className: "u-hover-primary-color ellipsis", "data-ellipsis-height": "25", href: '/' + __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].getLanguageName() + '/mywort/author/' + _this5.state.user.id },
                                _this5.state.user.firstName,
                                " ",
                                _this5.state.user.lastName
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            { className: "user-module__link" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "a",
                                { href: '/' + __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].getLanguageName() + '/user-space', className: "u-hover-primary-color" },
                                __WEBPACK_IMPORTED_MODULE_6__commons_i18n_Translation__["a" /* default */].translate("user-module.settings-mywort")
                            )
                        )
                    )
                ),
                mainModule
            );
        };

        _this5.render = function () {
            if (_this5.state.loading) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "user-module--loader" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_16__images_loader_medium_gif___default.a })
                );
            }

            if (_this5.state.user) return _this5.renderLoggedUserModule();else return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoginAndRegister, { user: _this5.state.user,
                posts: _this5.state.posts,
                totalPostsCount: _this5.state.totalPostsCount,
                onAddPost: _this5.addPost });
        };

        _this5.state = _this5.initialState();
        return _this5;
    }

    _createClass(UserModule, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.listenTo(__WEBPACK_IMPORTED_MODULE_3__commons__["p" /* UserStore */], this._onStoreChange);
            __WEBPACK_IMPORTED_MODULE_3__commons__["m" /* UserActions */].getUser();
        }
    }]);

    return UserModule;
}(__WEBPACK_IMPORTED_MODULE_2_sp_react_commons__["RefluxComponent"]), _class5.propTypes = {
    user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    posts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    totalPostsCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    onAddPost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, _class5.defaultProps = {
    posts: [],
    totalPostsCount: 0
}, _temp5);


/***/ }),

/***/ 1567:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/mywort/mywort-logo--negative.png";

/***/ }),

/***/ 1568:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/usermodule/01.gif";

/***/ }),

/***/ 1569:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/usermodule/01@2x.gif";

/***/ }),

/***/ 1570:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/usermodule/02.gif";

/***/ }),

/***/ 1571:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/usermodule/02@2x.gif";

/***/ }),

/***/ 1572:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/usermodule/03.gif";

/***/ }),

/***/ 1573:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/usermodule/03@2x.gif";

/***/ }),

/***/ 1574:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/loader-medium.gif";

/***/ }),

/***/ 1575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddPostButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sp_react_commons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sp_react_commons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sp_react_commons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_Translation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_UserStore__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_UserActions__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_Svg__ = __webpack_require__(7);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var AddPostButtonPresenter = function (_React$Component) {
    _inherits(AddPostButtonPresenter, _React$Component);

    function AddPostButtonPresenter() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, AddPostButtonPresenter);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddPostButtonPresenter.__proto__ || Object.getPrototypeOf(AddPostButtonPresenter)).call.apply(_ref, [this].concat(args))), _this), _this.renderFloatAction = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "a",
                { href: "/" + __WEBPACK_IMPORTED_MODULE_2__i18n_Translation__["a" /* default */].getLanguageName() + "/mywort/edit#/post/create", className: "mywort-btn--float-action" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_Svg__["a" /* default */], { id: "watermark-blog", className: "mywort-header__btn__svg" })
            );
        }, _this.renderInlineButton = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "a",
                { href: "/" + __WEBPACK_IMPORTED_MODULE_2__i18n_Translation__["a" /* default */].getLanguageName() + "/mywort/edit#/post/create", className: "mywort-btn mywort-btn--big-letters mywort-btn--outlined-transparent mywort-btn--radius mywort-header__btn" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_Svg__["a" /* default */], { id: "watermark-blog", className: "mywort-header__btn__svg" }),
                " ",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { className: "hide-for-small hide-for-medium" },
                    __WEBPACK_IMPORTED_MODULE_2__i18n_Translation__["a" /* default */].translate("commons.new-contribution")
                )
            );
        }, _this.render = function () {
            if (_this.props.style === 'float') return _this.renderFloatAction();else return _this.renderInlineButton();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return AddPostButtonPresenter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var AddPostButton = function (_RefluxComponent) {
    _inherits(AddPostButton, _RefluxComponent);

    function AddPostButton(props) {
        _classCallCheck(this, AddPostButton);

        var _this2 = _possibleConstructorReturn(this, (AddPostButton.__proto__ || Object.getPrototypeOf(AddPostButton)).call(this, props));

        _this2.initialState = function () {
            return {};
        };

        _this2._onStoreChange = function (data) {
            _this2.setState({ user: data.user });
        };

        _this2.render = function () {
            if (_this2.state.user && _this2.state.user.myWortAccess) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AddPostButtonPresenter, { user: _this2.state.user, style: _this2.props.style });
            }
            return null;
        };

        _this2.state = _this2.initialState();
        return _this2;
    }

    _createClass(AddPostButton, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.listenTo(__WEBPACK_IMPORTED_MODULE_3__stores_UserStore__["a" /* default */], this._onStoreChange);
            __WEBPACK_IMPORTED_MODULE_4__actions_UserActions__["a" /* default */].getUser();
        }
    }]);

    return AddPostButton;
}(__WEBPACK_IMPORTED_MODULE_1_sp_react_commons__["RefluxComponent"]);



/***/ }),

/***/ 1576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FoundationComponents__ = __webpack_require__(749);
/* unused harmony reexport FoundationComponents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocalityHeaderGroup__ = __webpack_require__(1577);
/* unused harmony reexport LocalityHeaderGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MywortSearch__ = __webpack_require__(1578);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__MywortSearch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Post__ = __webpack_require__(750);
/* unused harmony reexport Post */
/**
 * This package contains the highly generic components, which could be reused by other projets.
 *
 * @package components
 */









/***/ }),

/***/ 1577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// TODO RCH : not used for the moment

var LocalityHeaderGroup = function (_React$Component) {
    _inherits(LocalityHeaderGroup, _React$Component);

    function LocalityHeaderGroup() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, LocalityHeaderGroup);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LocalityHeaderGroup.__proto__ || Object.getPrototypeOf(LocalityHeaderGroup)).call.apply(_ref, [this].concat(args))), _this), _this.locateBrowser = function () {
            navigator.geolocation.getCurrentPosition(function (position) {
                //The user's browser accepted to share its geolocation
                // eslint-disable-next-line
                var geolocation = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                };
            }, function () {});
        }, _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                { type: "button", className: "mywort-action-group__btn mywort-btn mywort-btn--invert", onClick: _this.locateBrowser },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "iw-location-arrow" })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return LocalityHeaderGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);



/***/ }),

/***/ 1578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MywortSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flow__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_map__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_take__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_sortBy__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sp_react_commons__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sp_react_commons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sp_react_commons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_i18n_Translation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_Api__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commons_components_CustomSelect__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_Svg__ = __webpack_require__(7);





var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var buildOption = function buildOption(id, name, label, onSelect, permaLink, render) {
    return { id: id, name: name, label: label, onSelect: onSelect, permaLink: permaLink, render: render };
};

var MAX_RESULTS = 25; // Number of max results displayed in the input search

var MywortSearch = (_temp = _class = function (_React$Component) {
    _inherits(MywortSearch, _React$Component);

    function MywortSearch(props) {
        _classCallCheck(this, MywortSearch);

        var _this = _possibleConstructorReturn(this, (MywortSearch.__proto__ || Object.getPrototypeOf(MywortSearch)).call(this, props));

        _this.initialState = function () {
            return {
                localities: [],
                groups: []
            };
        };

        _this.transformOptions = function (options, icon, onSelect) {
            return __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_map___default()(function (o) {
                return buildOption(o.id, o.name, o.label ? o.label : o.name, onSelect, o.permaLink, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'div',
                    { className: 'mywort-search-menu__option' },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__svg_Svg__["a" /* default */], { id: icon, className: 'mywort-search-menu__option__svg' }),
                    o.name
                ));
            }), __WEBPACK_IMPORTED_MODULE_3_lodash_fp_sortBy___default()(function (o) {
                return o.name;
            }), __WEBPACK_IMPORTED_MODULE_2_lodash_fp_take___default()(MAX_RESULTS))(options);
        };

        _this.transformLocalitiesOptions = function (localities, input) {
            return _this.transformOptions(localities, "fa-location-arrow", _this.onSelectLocality, input);
        };

        _this.transformGroupsOptions = function (groups, input) {
            return _this.transformOptions(groups, "fa-users", _this.onSelectGroup, input);
        };

        _this.getOptions = function (input) {
            var options = [];
            // Display a default option first to let user go to search page if he click on it
            if (input && input.length > 0) {
                options.push(buildOption('localities-search-input-query', __WEBPACK_IMPORTED_MODULE_7__commons_i18n_Translation__["a" /* default */].translate("search.for", { input: input }), input, _this.onChangeSearch, "", __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'div',
                    { className: 'mywort-search-menu__option' },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__svg_Svg__["a" /* default */], { id: 'fa-file-text', className: 'mywort-search-menu__option__svg' }),
                    __WEBPACK_IMPORTED_MODULE_7__commons_i18n_Translation__["a" /* default */].translate("search.for", { input: input })
                )));
            }

            return options.concat(_this.state.localities).concat(_this.state.groups);
        };

        _this.search = function (input, cb) {
            // Search for localities + groups, store results asap and display final results when everything has been loaded
            __WEBPACK_IMPORTED_MODULE_6_sp_react_commons__["Request"].all(function () {
                return __WEBPACK_IMPORTED_MODULE_8__api_Api__["c" /* SearchApi */].searchLocality({ query: input }).then(function (localities) {
                    _this.setState({ localities: _this.transformLocalitiesOptions(localities, input) });
                });
            }, function () {
                return __WEBPACK_IMPORTED_MODULE_8__api_Api__["c" /* SearchApi */].searchGroup({ query: input }).then(function (groups) {
                    _this.setState({ groups: _this.transformGroupsOptions(groups, input) });
                });
            }).then(function () {
                return cb(_this.getOptions(input));
            });
        };

        _this.loadOptions = function (input, cb) {
            if (input && input.length !== 0) {
                _this.search(input, cb);
            } else {
                cb(null);
            }
        };

        _this.onSelectLocality = function (locality) {
            return window.location = locality.permaLink;
        };

        _this.onSelectGroup = function (group) {
            return window.location = group.permaLink;
        };

        _this.onChangeSearch = function (option) {
            return window.location = "/" + __WEBPACK_IMPORTED_MODULE_7__commons_i18n_Translation__["a" /* default */].getLanguageName() + "/mywort/search#/?query=" + encodeURIComponent(option.label);
        };

        _this.onChangeSelection = function (option) {
            return option ? option.onSelect(option) : null;
        };

        _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(MywortSearchPresenter, {
                selection: _this.state.selection,
                onChangeSelection: _this.onChangeSelection,
                loadOptions: _this.loadOptions
            });
        };

        _this.state = _this.initialState(props);
        return _this;
    }

    return MywortSearch;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component), _class.propTypes = {
    selection: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
    onChangeSelection: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    loadOptions: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
}, _class.defaultProps = {
    selection: null,
    onChangeSelection: function onChangeSelection() {},
    loadOptions: function loadOptions() {}
}, _temp);


var MywortSearchPresenter = function (_React$Component2) {
    _inherits(MywortSearchPresenter, _React$Component2);

    function MywortSearchPresenter(props) {
        _classCallCheck(this, MywortSearchPresenter);

        var _this2 = _possibleConstructorReturn(this, (MywortSearchPresenter.__proto__ || Object.getPrototypeOf(MywortSearchPresenter)).call(this, props));

        _this2.componentDidMount = function () {
            // Create event to mount event listeners on touch and scroll, search.js
            var event = document.createEvent('Event');
            event.initEvent('search-mount', true, true);
            window.dispatchEvent(event);
        };

        _this2.onFocus = function (event) {
            if ($(document).find('.Select-option.is-focused').length > 0) {
                var itemHeight = $(".Select-option.is-focused").height();
                var middle = $(".Select-menu-outer").height() / 2;
                if (event.keyCode === 40) {
                    $(".Select-menu-outer").scrollTop($(".Select-option.is-focused")[0].offsetTop - middle + itemHeight);
                } else {
                    $(".Select-menu-outer").scrollTop($(".Select-option.is-focused")[0].offsetTop - middle);
                }
            }
        };

        _this2.render = function () {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commons_components_CustomSelect__["a" /* default */], {
                async: true,
                debounceTime: 400,
                placeholder: __WEBPACK_IMPORTED_MODULE_7__commons_i18n_Translation__["a" /* default */].translate("search.placeholder"),
                searchPromptText: __WEBPACK_IMPORTED_MODULE_7__commons_i18n_Translation__["a" /* default */].translate("search.starttyping"),
                value: _this2.props.selection,
                onChange: _this2.props.onChangeSelection,
                loadOptions: function loadOptions(input, asyncSelectCallback) {
                    return _this2.props.loadOptions(input, asyncSelectCallback);
                },
                valueKey: 'id',
                labelKey: 'label',
                minimumInput: 2,
                openOnFocus: true,
                optionRenderer: function optionRenderer(option) {
                    return option.render;
                },
                scrollMenuIntoView: false,
                ignoreAccents: false,
                arrowRenderer: function arrowRenderer() {
                    return null;
                },
                onInputKeyDown: _this2.onFocus,
                cache: false,
                autoBlur: true
            });
        };

        return _this2;
    }

    return MywortSearchPresenter;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/***/ }),

/***/ 742:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__ = __webpack_require__(14);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SearchTitle = function (_React$Component) {
    _inherits(SearchTitle, _React$Component);

    function SearchTitle() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchTitle);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchTitle.__proto__ || Object.getPrototypeOf(SearchTitle)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
            var msg = !__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default()(_this.props.query) ? __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].translate("search.results-for", { item: _this.props.query }) : __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].translate("search.results-all");

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "mywort-search-page__title" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "h2",
                    { className: "mywort-heading" },
                    msg
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return SearchTitle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);



/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchPostList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_index__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_lazyload__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_Svg__ = __webpack_require__(7);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var PostPresenter = function (_React$Component) {
    _inherits(PostPresenter, _React$Component);

    function PostPresenter() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PostPresenter);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PostPresenter.__proto__ || Object.getPrototypeOf(PostPresenter)).call.apply(_ref, [this].concat(args))), _this), _this.renderPublisher = function () {
            if (_this.props.post.publisher.isGroup) return _this.renderGroup();

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "a",
                { href: _this.props.post.publisher.publicPermalink },
                _this.props.post.publisher.avatarUrl ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { className: "mywort-avatar mywort-avatar--small", src: _this.props.post.publisher.avatarUrl, alt: _this.props.post.publisher.fullName }),
                    "\xA0"
                ) : null,
                _this.props.post.publisher.fullName
            );
        }, _this.renderGroup = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "a",
                { href: _this.props.post.publisher.publicPermalink },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_Svg__["a" /* default */], { id: "fa-users", className: "u-text-mywort mywort-post__meta__publisher-group__svg" }),
                " ",
                _this.props.post.publisher.fullName
            );
        }, _this.renderImage = function () {
            if (_this.props.post.mwTeaserMedium) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "figure",
                    { className: "mywort-teaser__picture mywort-teaser__section" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "a",
                        { href: _this.props.post.permaLink },
                        _this.props.post.style ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { dangerouslySetInnerHTML: _this.svgMarkup(_this.props.post.style) }) : null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4_react_lazyload___default.a,
                            { height: 95, once: true, offset: 250, debounce: 150, placeholder: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commons_index__["g" /* RandomGradient */], null) },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: _this.props.post.mwTeaserMedium, alt: _this.props.post.title, style: { height: "95px" } })
                        )
                    )
                );
            } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "figure",
                    { className: "mywort-teaser__picture mywort-teaser__section" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "a",
                        { href: _this.props.post.permaLink },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commons_index__["g" /* RandomGradient */], null)
                    )
                );
            }
        }, _this.renderMoreDatesCounter = function () {
            if (_this.props.post.futureOccurrences.length > 5) {
                var moreDateCount = "+" + (_this.props.post.futureOccurrences.length - 5) + " " + __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].translate("public.more");
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { className: "date__item date__item--more" },
                    moreDateCount
                );
            }
        }, _this.renderEventDates = function () {
            var i = 0;
            var formattedDate = void 0;
            if (_this.props.post.futureOccurrences && _this.props.post.futureOccurrences.length > 0) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "date__container__search date__container__small" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "a",
                        { href: _this.props.post.permaLink },
                        _this.props.post.futureOccurrences.map(function (date) {
                            formattedDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('MMM') + " " + __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('D');
                            i++;
                            if (i < 6) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    "span",
                                    { key: date, className: "date__item date__item--future" },
                                    formattedDate
                                );
                            }
                        }),
                        " ",
                        _this.renderMoreDatesCounter()
                    )
                );
            } else {
                return true;
            }
        }, _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "article",
                { className: "mywort-teaser" },
                _this.renderImage(),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "mywort-teaser__section u-full-width" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "mywort-teaser__overtitle" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "a",
                            { href: _this.props.post.localityPermalink },
                            _this.props.post.locality.name
                        )
                    ),
                    _this.renderEventDates(),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "a",
                        { className: "color-hover-edition", href: _this.props.post.permaLink },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "h3",
                            { className: "mywort-teaser__title" },
                            _this.props.post.title
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "mywort-teaser__meta" },
                        _this.renderPublisher(),
                        ", ",
                        __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].translate("public.published-at"),
                        " ",
                        __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this.props.post.publishedAt).format(__WEBPACK_IMPORTED_MODULE_3__commons_index__["a" /* CommonsConstants */].SIMPLE_DATE_WITH_HOUR_DISPLAY_FORMAT[__WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].getLanguageName()])
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PostPresenter, [{
        key: "svgMarkup",
        value: function svgMarkup(postType) {
            var mywortSvgWatermark = '<svg class="watermark watermark--' + postType + '"><use xlink:href="#watermark-' + postType + '"></use></svg>';
            return { __html: mywortSvgWatermark };
        }
    }]);

    return PostPresenter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var SearchPostList = function (_React$Component2) {
    _inherits(SearchPostList, _React$Component2);

    function SearchPostList() {
        var _ref2;

        var _temp2, _this2, _ret2;

        _classCallCheck(this, SearchPostList);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = SearchPostList.__proto__ || Object.getPrototypeOf(SearchPostList)).call.apply(_ref2, [this].concat(args))), _this2), _this2.renderLoading = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "u-text-center u-m-v" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "h6",
                    { className: "mywort-heading" },
                    __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].translate("search.loading")
                )
            );
        }, _this2.renderEmptyResults = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "u-text-center u-m-v" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "h6",
                    { className: "mywort-heading" },
                    __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].translate("search.noresults")
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "u-m-v" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "button",
                        { className: "mywort-btn mywort-btn", onClick: _this2.props.onResetFilters },
                        __WEBPACK_IMPORTED_MODULE_2__commons_i18n_Translation__["a" /* default */].translate("search.filters.reset")
                    )
                )
            );
        }, _this2.render = function () {
            if (_this2.props.loading) {
                return _this2.renderLoading();
            }
            if (_this2.props.results.length < 1) {
                return _this2.renderEmptyResults();
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                _this2.props.results.map(function (post, idx) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PostPresenter, { post: post, key: idx });
                })
            );
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    return SearchPostList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);



/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceCheck = exports.lazyload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = __webpack_require__(1547);

var _scrollParent = __webpack_require__(1548);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _debounce = __webpack_require__(1549);

var _debounce2 = _interopRequireDefault(_debounce);

var _throttle = __webpack_require__(1550);

var _throttle2 = _interopRequireDefault(_throttle);

var _decorator = __webpack_require__(1551);

var _decorator2 = _interopRequireDefault(_decorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = _reactDom2.default.findDOMNode(component);

  var parentTop = void 0;
  var parentHeight = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentHeight = _parent$getBoundingCl.height;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height

  // check whether the element is visible in the intersection
  var top = void 0;
  var height = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    height = _node$getBoundingClie.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    height = defaultBoundingClientRect.height;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  if (!node) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof process !== 'undefined' && "production" !== 'production') {
        if (_react2.default.Children.count(this.props.children) > 1) {
          console.warn('[react-lazyload] Only one child is allowed to be passed to `LazyLoad`.');
        }

        if (this.props.wheel) {
          // eslint-disable-line
          console.warn('[react-lazyload] Props `wheel` is not supported anymore, try set `overflow` for lazy loading in overflow containers.');
        }

        // Warn the user if placeholder and height is not specified and the rendered height is 0
        if (!this.props.placeholder && this.props.height === undefined && _reactDom2.default.findDOMNode(this).offsetHeight === 0) {
          console.warn('[react-lazyload] Please add `height` props to <LazyLoad> for better performance.');
        }
      }

      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var needResetFinalLazyLoadHandler = false;
      if (this.props.debounce !== undefined && delayType === 'throttle') {
        console.warn('[react-lazyload] Previous delay function is `throttle`, now switching to `debounce`, try setting them unanimously');
        needResetFinalLazyLoadHandler = true;
      } else if (delayType === 'debounce' && this.props.debounce === undefined) {
        console.warn('[react-lazyload] Previous delay function is `debounce`, now switching to `throttle`, try setting them unanimously');
        needResetFinalLazyLoadHandler = true;
      }

      if (needResetFinalLazyLoadHandler) {
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, _event.on)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0) {
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
    }
  }]);

  return LazyLoad;
}(_react.Component);

LazyLoad.propTypes = {
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  unmountIfInvisible: _propTypes2.default.bool
};

LazyLoad.defaultProps = {
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var lazyload = exports.lazyload = _decorator2.default;
exports.default = LazyLoad;
exports.forceCheck = lazyLoadHandler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),

/***/ 745:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_Api__ = __webpack_require__(134);
/**
 * Created by bladron on 07/04/16.
 */



var PostActions = {
    init: __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createAction(),
    getPostBeforeDate: __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createAction({ asyncResult: true }),
    getMorePost: __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createAction(),

    getEventsBeforeDate: __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createAction({ asyncResult: true }),
    getMoreEvents: __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createAction(),

    getLatestGroups: __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createAction({ asyncResult: true }),
    getMoreGroups: __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createAction(),

    getLatestLocalities: __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createAction({ asyncResult: true }),
    getMoreLocalities: __WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createAction()
};

PostActions.getPostBeforeDate.listen(function (date) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_Api__["b" /* PostApi */].getPostBeforeDate(date).then(function (data) {
        _this.completed(data);
    });
});

PostActions.getEventsBeforeDate.listen(function (date, excludeIds) {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__api_Api__["b" /* PostApi */].getEvents(date, excludeIds).then(function (data) {
        _this2.completed(data);
    });
});

PostActions.getLatestGroups.listen(function (skip) {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__api_Api__["b" /* PostApi */].getLatestGroups(skip).then(function (data) {
        _this3.completed(data);
    });
});

PostActions.getLatestLocalities.listen(function (skip) {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_1__api_Api__["b" /* PostApi */].getLatestLocalities(skip).then(function (data) {
        _this4.completed(data);
    });
});

/* harmony default export */ __webpack_exports__["a"] = (PostActions);

/***/ }),

/***/ 746:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_PostActions__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configurations_Constants__ = __webpack_require__(135);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Created by bladron on 07/04/16.
 */






var DEFAULT_DATE = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format("YYYY-MM-DDTHH:mm:ss.SSS") + "-0100";

var PostStore = function (_Reflux$Store) {
    _inherits(PostStore, _Reflux$Store);

    function PostStore() {
        _classCallCheck(this, PostStore);

        var _this = _possibleConstructorReturn(this, (PostStore.__proto__ || Object.getPrototypeOf(PostStore)).call(this));

        _this.onGetMorePost = function () {
            var beforeDate = _this.posts.length > 0 ? _this.posts[_this.posts.length - 1].publishedAt : DEFAULT_DATE;
            __WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getPostBeforeDate(beforeDate);
        };

        _this.onGetPost = function (result) {
            _this.posts = _this.posts.concat(result.teasers);
            _this.remainingPosts = 1;
            if (result.teasers.length < __WEBPACK_IMPORTED_MODULE_5__configurations_Constants__["a" /* default */].POST_BY_CALL) {
                _this.remainingPosts = 0;
            }
            _this.trigger();
        };

        _this.onGetMoreEvents = function () {
            var beforeDate = _this.events.length > 0 ? _this.events[_this.events.length - 1].futureOccurrences[0] : DEFAULT_DATE;
            // Find all posts of this date to exclude in query
            var excludeIds = __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(_this.events, function (e) {
                if (!e.futureOccurrences) {
                    return false;
                }
                return e.nextOccurrence === beforeDate;
            }), 'id');
            __WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getEventsBeforeDate(__WEBPACK_IMPORTED_MODULE_4_moment___default()(beforeDate).format("YYYY-MM-DD"), excludeIds);
        };

        _this.onGetEvents = function (result) {
            _this.events = _this.events.concat(result.teasers);
            _this.remainingEvents = 1;
            if (result.teasers.length < __WEBPACK_IMPORTED_MODULE_5__configurations_Constants__["a" /* default */].POST_BY_CALL) {
                _this.remainingEvents = 0;
            }
            _this.trigger();
        };

        _this.onGetMoreGroups = function () {
            var skip = _this.groups.length > 0 ? _this.groups.length : 0;
            __WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getLatestGroups(skip);
        };

        _this.onGetGroups = function (result) {
            _this.groups = _this.groups.concat(result.groups);
            _this.remainingGroups = 1;
            if (result.groups.length < 10) {
                _this.remainingGroups = 0;
            }
            _this.trigger();
        };

        _this.onGetMoreLocalities = function () {
            var skip = _this.localities.length > 0 ? _this.localities.length : 0;
            __WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getLatestLocalities(skip);
        };

        _this.onGetLocalities = function (result) {
            _this.localities = _this.localities.concat(result.localities);
            _this.remainingLocalities = 1;
            if (result.localities.length < 10) {
                _this.remainingLocalities = 0;
            }
            _this.trigger();
        };

        _this.listenTo(__WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getEventsBeforeDate.completed, _this.onGetEvents);
        _this.listenTo(__WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getMoreEvents, _this.onGetMoreEvents);

        _this.listenTo(__WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getPostBeforeDate.completed, _this.onGetPost);
        _this.listenTo(__WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getMorePost, _this.onGetMorePost);

        _this.listenTo(__WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getLatestGroups.completed, _this.onGetGroups);
        _this.listenTo(__WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getMoreGroups, _this.onGetMoreGroups);

        _this.listenTo(__WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getLatestLocalities.completed, _this.onGetLocalities);
        _this.listenTo(__WEBPACK_IMPORTED_MODULE_3__actions_PostActions__["a" /* default */].getMoreLocalities, _this.onGetMoreLocalities);

        _this.posts = [];
        _this.events = [];
        _this.localities = [];
        _this.groups = [];
        _this.remainingPosts = 1;
        _this.remainingEvents = 1;
        _this.remainingGroups = 1;
        _this.remainingLocalities = 1;

        _this.onlyFollowed = false;

        _this.userPosts = [];
        return _this;
    }

    /**
     * This method is used by server-side rendering
     *
     * Once MyWort React appliction is loaded, we initialize this store by calling this function with posts/events taken from a global variable in the DOM (see mywort/frontend/js/app.js)
     * @param posts {Array} array of initial posts
     * @param events {Array} array of initial events
     * @param localities {Array} array of initial events
     * @param groups {Array} array of initial groups
     */


    _createClass(PostStore, [{
        key: "initialize",
        value: function initialize(posts, events, localities, groups) {
            this.posts = posts;
            this.events = events;
            this.localities = localities;
            this.groups = groups;

            if (!this.posts || this.posts.length < __WEBPACK_IMPORTED_MODULE_5__configurations_Constants__["a" /* default */].POST_BY_CALL) {
                this.remainingPosts = 0;
            }

            if (!this.events || this.events.length < __WEBPACK_IMPORTED_MODULE_5__configurations_Constants__["a" /* default */].POST_BY_CALL) {
                this.remainingEvents = 0;
            }

            if (!this.localities || this.localities.length < 10) {
                this.remainingLocalities = 0;
            }

            if (!this.groups || this.groups.length < 10) {
                this.remainingGroups = 0;
            }
        }
    }]);

    return PostStore;
}(__WEBPACK_IMPORTED_MODULE_2_reflux___default.a.Store);

/* harmony default export */ __webpack_exports__["a"] = (new PostStore());

/***/ }),

/***/ 749:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Row */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Col; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Row = function (_React$Component) {
    _inherits(Row, _React$Component);

    function Row() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Row);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Row.__proto__ || Object.getPrototypeOf(Row)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                _extends({}, _this.props, { className: _this.props.className ? "row " + _this.props.className : "row" }),
                _this.props.children
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Row;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Col = function (_React$Component2) {
    _inherits(Col, _React$Component2);

    function Col() {
        var _ref2;

        var _temp2, _this2, _ret2;

        _classCallCheck(this, Col);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = Col.__proto__ || Object.getPrototypeOf(Col)).call.apply(_ref2, [this].concat(args))), _this2), _this2.render = function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                _extends({}, _this2.props, { className: _this2.props.className ? "pure-u-1 " + _this2.props.className : "pure-u-1" }),
                _this2.props.children
            );
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    return Col;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),

/***/ 750:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Post; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_configurations_Constants__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_i18n_Translation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_components_RandomGradient__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_mywort_default_avatar_png__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_mywort_default_avatar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_mywort_default_avatar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_Svg__ = __webpack_require__(7);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var LAYOUTS = {
    SMALL: "small",
    DEFAULT: "default",
    FULL: "full"
};

var Post = (_temp2 = _class = function (_React$Component) {
    _inherits(Post, _React$Component);

    function Post() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Post);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Post.__proto__ || Object.getPrototypeOf(Post)).call.apply(_ref, [this].concat(args))), _this), _this.getTeaserPicture = function () {
            return _this.props.teaserPicture || _this.props.videoThumbnail;
        }, _this.renderMainPicture = function () {
            return _this.getTeaserPicture() ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { src: _this.getTeaserPicture(), alt: _this.props.postTitle }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commons_components_RandomGradient__["a" /* default */], { imgClassName: "u-fluid-image mywort-post__picture--no-picture", randomGradient: _this.props.randomGradient });
        }, _this.renderPublisherAvatar = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { src: _this.props.publisherAvatarUri, alt: _this.props.publisherName, className: "mywort-post__avatar" });
        }, _this.renderPublisherName = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "mywort-post__publisher" },
                _this.props.publisherName
            );
        }, _this.renderGroupName = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "mywort-post__publisher-group-wrapper" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "mywort-post__publisher-group" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__svg_Svg__["a" /* default */], { id: "fa-users", className: "u-text-mywort mywort-post__publisher-group__svg" }),
                    "\xA0",
                    _this.props.publisherName
                )
            );
        }, _this.renderPublisherDefault = function () {
            if (_this.props.isGroup) {
                return _this.renderGroupName();
            }
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                null,
                _this.renderPublisherAvatar(),
                _this.renderPublisherName()
            );
        }, _this.renderPublishedAt = function () {
            return _this.props.publishedAt ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "mywort-post__footer-published-at left" },
                __WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.props.publishedAt).format(__WEBPACK_IMPORTED_MODULE_4__commons_configurations_Constants__["a" /* default */].SIMPLE_DATE_DISPLAY_FORMAT[__WEBPACK_IMPORTED_MODULE_5__commons_i18n_Translation__["a" /* default */].getLanguageName()])
            ) : null;
        }, _this.renderEventWatermark = function () {
            if (!_this.props.nextOccurrence) return null;

            var day = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.props.nextOccurrence, "YYYY-MM-DD");
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "mywort-post__date" },
                day.format("DD"),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "mywort-post__date-month" },
                    day.format("MMM")
                )
            );
        }, _this.renderPostTypeWatermark = function () {
            if (_this.props.nextOccurrence) return null;

            if (_this.props.maybeMissionId) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { className: "watermark watermark--teaser mywortMission" });
            }

            if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default()(_this.props.postType)) return null;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { dangerouslySetInnerHTML: _this.svgMarkup(_this.props.postType) });
        }, _this.renderPostTitle = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "header",
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "h3",
                    { className: "mywort-post__title u-text-center-v" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "a",
                        { className: "mywort-post__title-inside mywort-post__link", href: _this.props.postPermalink },
                        _this.props.postTitle
                    )
                )
            );
        }, _this.renderLocality = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "mywort-post__footer-locality right" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "a",
                    { className: "mywort-post__link", href: _this.props.localityPermalink },
                    _this.props.localityName
                )
            );
        }, _this.renderDefaultLayout = function () {
            var postOrEventClass = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('mywort-post mywort-post--default', { 'mywort-post--event': _this.props.nextOccurrence });
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "article",
                { className: postOrEventClass },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "a",
                    { className: "mywort-post__picture-wrapper", href: _this.props.postPermalink },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "span",
                        { className: "u-fluid-container" },
                        _this.renderMainPicture()
                    ),
                    _this.renderPostTypeWatermark(),
                    _this.renderEventWatermark()
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "mywort-post__content" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "a",
                        { className: "mywort-post__link", href: _this.props.publisherPermalink },
                        _this.renderPublisherDefault()
                    ),
                    _this.renderPostTitle(),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "mywort-post__footer" },
                        _this.renderPublishedAt(),
                        _this.renderLocality(),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "u-clear" })
                    )
                )
            );
        }, _this.renderSmallLayout = function () {
            var postOrEventClass = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('mywort-post mywort-post--small', { 'mywort-post--event': _this.props.nextOccurrence });
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "article",
                { className: postOrEventClass },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "mywort-post__content" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "a",
                        { className: "mywort-post__link", href: _this.props.publisherPermalink },
                        _this.renderPublisherDefault()
                    ),
                    _this.renderPostTitle(),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "mywort-post__footer" },
                        _this.renderPublishedAt(),
                        _this.renderLocality(),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "u-clear" })
                    )
                )
            );
        }, _this.renderFullLayout = function () {
            var postOrEventClass = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('mywort-post mywort-post--full-condensed', { 'mywort-post--event': _this.props.nextOccurrence });
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "article",
                {
                    className: postOrEventClass },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "a",
                    { className: "mywort-post__picture-wrapper mywort-post__link", href: _this.props.postPermalink },
                    _this.renderMainPicture(),
                    _this.renderEventWatermark(),
                    _this.renderPostTypeWatermark()
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "mywort-post__content" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "mywort-post__header" },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            "a",
                            { className: "mywort-post__link",
                                href: _this.props.publisherPermalink },
                            _this.renderPublisherAvatar()
                        ),
                        _this.renderPostTitle()
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "mywort-post__footer" },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            "div",
                            { className: "mywort-post__publisher left" },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                "a",
                                { className: "mywort-post__link",
                                    href: _this.props.publisherPermalink },
                                _this.renderPublisherName()
                            )
                        ),
                        _this.renderLocality()
                    )
                )
            );
        }, _this.render = function () {
            if (_this.props.layout === Post.LAYOUTS.SMALL) return _this.renderSmallLayout();else if (_this.props.layout === Post.LAYOUTS.FULL) return _this.renderFullLayout();else return _this.renderDefaultLayout();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Post, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            return this.props.postId !== nextProps.postId; // For performances reasons
        }
    }, {
        key: "svgMarkup",
        value: function svgMarkup(postType) {
            var mywortSvgWatermark = '<svg class="watermark watermark--' + postType + '"><use xlink:href="#watermark-' + postType + '"></use></svg>';
            return { __html: mywortSvgWatermark };
        }
    }]);

    return Post;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class.defaultProps = {
    layout: LAYOUTS.DEFAULT,
    publisherAvatarUri: __WEBPACK_IMPORTED_MODULE_8__images_mywort_default_avatar_png___default.a
}, _class.propTypes = {
    publisherAvatarUri: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    publisherPermalink: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    publisherName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    postId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    postTitle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    postPermalink: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    postType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    publishedAt: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    localityName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    localityPermalink: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    teaserPicture: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    videoThumbnail: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    layout: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    isGroup: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    nextOccurrence: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    randomGradient: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    maybeMissionId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
}, _class.LAYOUTS = LAYOUTS, _temp2);


/***/ }),

/***/ 752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserPostList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_take__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configurations_Constants__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_Svg__ = __webpack_require__(7);


var _class2, _temp3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var UserPostRow = function (_React$Component) {
    _inherits(UserPostRow, _React$Component);

    function UserPostRow() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, UserPostRow);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserPostRow.__proto__ || Object.getPrototypeOf(UserPostRow)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
            if (_this.props.post) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "article",
                { className: "pure-g user-module__article" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "pure-u-20-24" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "a",
                        { href: _this.props.post.permaLink },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            "div",
                            { className: "user-module__title" },
                            _this.props.post.title
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            "div",
                            { className: "user-module__date" },
                            __WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.props.post.publishedAt).format(__WEBPACK_IMPORTED_MODULE_6__commons__["a" /* CommonsConstants */].SIMPLE_DATE_DISPLAY_FORMAT[__WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].getLanguageName()])
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "pure-u-4-24" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "a",
                        { href: "/" + __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].getLanguageName() + "/mywort/edit#/post/" + _this.props.post.id },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__svg_Svg__["a" /* default */], { id: "watermark-blog", className: "icon user-module__left__icon u-hover-primary-color" })
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return UserPostRow;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var UserPostList = (_temp3 = _class2 = function (_React$Component2) {
    _inherits(UserPostList, _React$Component2);

    function UserPostList() {
        var _ref2;

        var _temp2, _this2, _ret2;

        _classCallCheck(this, UserPostList);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = UserPostList.__proto__ || Object.getPrototypeOf(UserPostList)).call.apply(_ref2, [this].concat(args))), _this2), _this2.render = function () {
            if (_this2.props.posts.length === 0) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "article",
                { className: "user-module__article" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "pure-u-1 pure-u-sm-24-24 pure-u-lg-24-24" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "user-module__title" },
                        __WEBPACK_IMPORTED_MODULE_4__commons_i18n_Translation__["a" /* default */].translate("user-module.empty-post")
                    )
                )
            );

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_lodash_take___default()(_this2.props.posts, __WEBPACK_IMPORTED_MODULE_5__configurations_Constants__["a" /* default */].USER_MODULE_POSTS_LIMIT).map(function (post) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(UserPostRow, { key: 'userpost-' + post.id, post: post });
                })
            );
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    return UserPostList;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class2.propTypes = {
    posts: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,
    totalPostsCount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired
}, _class2.defaultProps = {
    posts: [],
    totalPostsCount: 0
}, _temp3);


/***/ })

},[1364]);


// WEBPACK FOOTER //
// javascripts/mywortFrontend.js